import Dope from "../../assets/logo/dope.webp";
import ny from "../../assets/logo/NYBurrito.webp";
import society from "../../assets/logo/society.webp";
import tibbs from "../../assets/logo/tibbs.webp";
import ccc from "../../assets/logo/chaos.png";
import pizzeria from "../../assets/logo/1441.webp";
import highness from "../../assets/logo/highness.webp";
import murruku from "../../assets/logo/murruku.webp";
// import beverage from "../../assets/logo/beverage.webp";
import nesco from "../../assets/logo/nesco.webp";
import social from "../../assets/logo/social.webp";
import tingle from "../../assets/logo/tingle.webp";
import fresh from "../../assets/logo/freshpress.webp";
import hubston from "../../assets/logo/hubston.webp";
import maiva from "../../assets/logo/maiva.webp";
import beverage from "../../assets/logo/beverage.webp";
import subway from "../../assets/logo/subway.webp";

export const CafeList = {
  cafe1: () => {
    return (
      <>
        <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={tibbs} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">TIBBS FRANKIE</td>
          </tr>
          <tr class="head">
            <td colspan="3">MENU</td>
            <td>NEW PRICE</td>
            <td>GM/ML</td>
          </tr>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>

          <tr className="spacer">
            <td className="ft-Wt-700">VEG FRANKIE</td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td colSpan={3}>CLASSIC VEG</td>
            <td className="ft-Wt-700">200.00</td>
            <td className="ft-Wt-700">200 GMS</td>
          </tr>

          <tr>
            <td colSpan={3}>VEG SCHEZWAN</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">200 GMS</td>
          </tr>

          <tr>
            <td colSpan={3}>VEG CHEESE JELAPENO</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">200 GMS</td>
          </tr>

          <tr>
            <td colSpan={3}>JAIN ROLL</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">200 GMS</td>
          </tr>

          <tr>
            <td colSpan={3}>TAWA PANEER</td>
            <td className="ft-Wt-700">230.00</td>
            <td className="ft-Wt-700">200 GMS</td>
          </tr>

          <tr>
            <td colSpan={3}>CHILLY PANEER</td>
            <td className="ft-Wt-700">230.00</td>
            <td className="ft-Wt-700">200 GMS</td>
          </tr>

          <tr>
            <td colSpan={3}>EXTRA CHEESE</td>
            <td className="ft-Wt-700">50.00</td>
            <td className="ft-Wt-700">20 GMS</td>
          </tr>

          <tr>
            <td colSpan={3}>EXTRA CHIPOTLE SAUCE</td>
            <td className="ft-Wt-700">50.00</td>
            <td className="ft-Wt-700">50 GMS</td>
          </tr>

          <tr>
            <td colSpan={3}>EXTRA TANDOORI SAUCE</td>
            <td className="ft-Wt-700">50.00</td>
            <td className="ft-Wt-700">50 GMS</td>
          </tr>

          <tr>
            <td colSpan={3}>SHIKANJI</td>
            <td className="ft-Wt-700">60.00</td>
            <td className="ft-Wt-700">300 ML</td>
          </tr>

          <tr>
            <td colSpan={3}>GOOEY BROWNIE</td>
            <td className="ft-Wt-700">140.00</td>
            <td className="ft-Wt-700">90 GMS</td>
          </tr>

          <tr>
            <td colSpan={3}>AAM PANNA</td>
            <td className="ft-Wt-700">60.00</td>
            <td className="ft-Wt-700">300 ML</td>
          </tr>

          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="spacer">
            <td className="ft-Wt-700">PROTIROTI</td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td colSpan={3}>PROTIROTI - CHETTINAD SUKHA SOYA CHAAP ROLL</td>
            <td className="ft-Wt-700">240.00</td>
            <td className="ft-Wt-700">200 GMS</td>
          </tr>

          <tr>
            <td colSpan={3}>PROTIROTI - BHUNA SOYA CHAAP ROLL</td>
            <td className="ft-Wt-700">240.00</td>
            <td className="ft-Wt-700">200 GMS</td>
          </tr>
        </table>
        <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvG0yg7wyS3lVPIUbj9UaLAqtbZZpxtqU4I2N68A3Qv7Sm-KEqTSyLI7Hb&s=10"} />
            </td>
          </tr>
          <tr className="title">
            <td colSpan={3}>DRIP FACE</td>
          </tr>
          <tr className="head">
            <td>MENU</td>
            <td>PRICE</td>
            <td>GM/ML</td>
          </tr>

          <tr>
            <td>HOT CHOCOLATE</td>
            <td className="ft-Wt-700">300.00</td>
            <td className="ft-Wt-700">250 ml</td>
          </tr>
          <tr>
            <td>AMERICANO AF (ICED/HOT)</td>
            <td className="ft-Wt-700">200.00</td>
            <td className="ft-Wt-700">350 ml/250 ml</td>
          </tr>
          <tr>
            <td>LATTE (ICED/HOT)</td>
            <td className="ft-Wt-700">250.00</td>
            <td className="ft-Wt-700">350 ml/250 ml</td>
          </tr>
          <tr>
            <td>CAPPACUINO (ICED/HOT)</td>
            <td className="ft-Wt-700">250.00</td>
            <td className="ft-Wt-700">350 ml/250 ml</td>
          </tr>
          <tr>
            <td>MOCHA (ICED/HOT)</td>
            <td className="ft-Wt-700">270.00</td>
            <td className="ft-Wt-700">350 ml/250 ml</td>
          </tr>
          <tr>
            <td>DOUBLE ESPRESSO (ICED/HOT)</td>
            <td className="ft-Wt-700">150.00</td>
            <td className="ft-Wt-700">350 ml/250 ml</td>
          </tr>
          <tr>
            <td>V60 (POUR OVER) (ICED/HOT)</td>
            <td className="ft-Wt-700">250.00</td>
            <td className="ft-Wt-700">350 ml/250 ml</td>
          </tr>
          <tr>
            <td>CARAMEL MACCHIATO</td>
            <td className="ft-Wt-700">300.00</td>
            <td className="ft-Wt-700">350 ml</td>
          </tr>
          <tr>
            <td>VIETNAMESE ICED LATTE</td>
            <td className="ft-Wt-700">330.00</td>
            <td className="ft-Wt-700">350 ml</td>
          </tr>
          <tr>
            <td>COCONUT CRAY</td>
            <td className="ft-Wt-700">330.00</td>
            <td className="ft-Wt-700">350 ml</td>
          </tr>
          <tr>
            <td>STRAWBERRY CHOCOLATE LATTE</td>
            <td className="ft-Wt-700">300.00</td>
            <td className="ft-Wt-700">350 ml</td>
          </tr>
          <tr>
            <td>BROWN BUTTERCUP</td>
            <td className="ft-Wt-700">300.00</td>
            <td className="ft-Wt-700">350 ml</td>
          </tr>
          <tr>
            <td>FOAMY HAZELNUT</td>
            <td className="ft-Wt-700">300.00</td>
            <td className="ft-Wt-700">350 ml</td>
          </tr>
          <tr>
            <td>OG COLD COFFEE</td>
            <td className="ft-Wt-700">350.00</td>
            <td className="ft-Wt-700">350 ml</td>
          </tr>
          <tr>
            <td>DEATH BY DRIP</td>
            <td className="ft-Wt-700">350.00</td>
            <td className="ft-Wt-700">350 ml</td>
          </tr>
          <tr>
            <td>MANGO MINGLE</td>
            <td className="ft-Wt-700">270.00</td>
            <td className="ft-Wt-700">350 ml</td>
          </tr>
          <tr>
            <td>STRAWBERRY SWING</td>
            <td className="ft-Wt-700">270.00</td>
            <td className="ft-Wt-700">350 ml</td>
          </tr>
          <tr>
            <td>ICED MATCHA LATTE</td>
            <td className="ft-Wt-700">250.00</td>
            <td className="ft-Wt-700">350 ml</td>
          </tr>
          <tr>
            <td>MANGO MATCHA LATTE</td>
            <td className="ft-Wt-700">400.00</td>
            <td className="ft-Wt-700">350 ml</td>
          </tr>
          <tr>
            <td>ICED TEA (PEACH / LEMON)</td>
            <td className="ft-Wt-700">270.00</td>
            <td className="ft-Wt-700">350 ml</td>
          </tr>
          <tr>
            <td>TEAS (GREEN/CHAMOMILE/KADAK CHAI)</td>
            <td className="ft-Wt-700">270.00</td>
            <td className="ft-Wt-700">250 ml</td>
          </tr>
          <tr>
            <td>CLASSIC FRIES (SALTED/PERI-PERI)</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">250 gms</td>
          </tr>
          <tr>
            <td>SWEET PATATO FRIES (SALTED/PERI-PERI)</td>
            <td className="ft-Wt-700">270.00</td>
            <td className="ft-Wt-700">250 gms</td>
          </tr>
          <tr>
            <td>MINI SAMOSAS (5 PCS)</td>
            <td className="ft-Wt-700">180.00</td>
            <td className="ft-Wt-700">150 gms</td>
          </tr>
          <tr>
            <td>HUMUS & CRACKERS</td>
            <td className="ft-Wt-700">300.00</td>
            <td className="ft-Wt-700">140 gms</td>
          </tr>
          <tr>
            <td>GARLIC BREAD & CHEESE</td>
            <td className="ft-Wt-700">180.00</td>
            <td className="ft-Wt-700">180 gms</td>
          </tr>
          <tr>
            <td>JALEPENOS CHEESE POPPERS</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">130 gms</td>
          </tr>
          <tr>
            <td>JALEPENOS & CHEESE (JAIN)</td>
            <td className="ft-Wt-700">300.00</td>
            <td className="ft-Wt-700">180 gms</td>
          </tr>
          <tr>
            <td>PESTO PANEER DRIPWICH</td>
            <td className="ft-Wt-700">300.00</td>
            <td className="ft-Wt-700">135 gms</td>
          </tr>
          <tr>
            <td>TRUFFLE MUSHROOM WITH ARGULA & LETTUCE DRIPWICH</td>
            <td className="ft-Wt-700">350.00</td>
            <td className="ft-Wt-700">135 gms</td>
          </tr>
          <tr>
            <td>CHOCOLATE MOUSSE</td>
            <td className="ft-Wt-700">300.00</td>
            <td className="ft-Wt-700">120 gms</td>
          </tr>
          <tr>
            <td>DOT CAKE</td>
            <td className="ft-Wt-700">400.00</td>
            <td className="ft-Wt-700">150 gms</td>
          </tr>
          <tr>
            <td>TIRAMISU</td>
            <td className="ft-Wt-700">400.00</td>
            <td className="ft-Wt-700">150 gms</td>
          </tr>
          <tr>
            <td>TRES LECHES</td>
            <td className="ft-Wt-700">400.00</td>
            <td className="ft-Wt-700">150 gms</td>
          </tr>
        </table>
      </>
    );
  },
  cafe2: () => {
    return (
      <table>
        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        
        <tr className="title">
          <td colSpan={3}>CAFÉ BREWZ - CCD</td>
        </tr>
        <tr className="head">
          <td>BEVERAGES</td>
          <td>NEW PRICE</td>
          <td>GM/ML</td>
        </tr>

        <tr>
          <td>CAPPUCINNO</td>
          <td className="ft-Wt-700">220.00</td>
          <td className="ft-Wt-700">250 ml</td>
        </tr>
        <tr>
          <td>CAFÉ LATTE</td>
          <td className="ft-Wt-700">220.00</td>
          <td className="ft-Wt-700">250 ml</td>
        </tr>
        <tr>
          <td>CAFÉ MOCHA</td>
          <td className="ft-Wt-700">220.00</td>
          <td className="ft-Wt-700">250 ml</td>
        </tr>
        <tr>
          <td>AMERICANO</td>
          <td className="ft-Wt-700">220.00</td>
          <td className="ft-Wt-700">250 ml</td>
        </tr>
        <tr>
          <td>HOT CHOCOLATE</td>
          <td className="ft-Wt-700">180.00</td>
          <td className="ft-Wt-700">250 ml</td>
        </tr>
        <tr>
          <td>MASALA TEA</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">110 ml</td>
        </tr>
        <tr>
          <td>GREEN TEA</td>
          <td className="ft-Wt-700">70.00</td>
          <td className="ft-Wt-700">150 ml</td>
        </tr>
        <tr>
          <td>COLD COFFEE</td>
          <td className="ft-Wt-700">220.00</td>
          <td className="ft-Wt-700">300 ML</td>
        </tr>
        <tr>
          <td>ICE CHOCOLATE</td>
          <td className="ft-Wt-700">170.00</td>
          <td className="ft-Wt-700">300 ML</td>
        </tr>
        <tr>
          <td>ICE MOCHA</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">300 ML</td>
        </tr>
        <tr>
          <td>ICE AMERICANO</td>
          <td className="ft-Wt-700">220.00</td>
          <td className="ft-Wt-700">300 ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">SNACKS</td>
          <td></td>
          <td></td>
        </tr>

        <tr>
          <td>VEG MAXICAN PANINI S/W</td>
          <td className="ft-Wt-700">220.00</td>
          <td className="ft-Wt-700">190 gms</td>
        </tr>
        <tr>
          <td>MUMBAI MASALA CHEESE GRILLED S/W</td>
          <td className="ft-Wt-700">270.00</td>
          <td className="ft-Wt-700">230 gms</td>
        </tr>
        <tr>
          <td>VEG GRILL S/W (JAIN)</td>
          <td className="ft-Wt-700">220.00</td>
          <td className="ft-Wt-700">180 gms</td>
        </tr>
        <tr>
          <td>MELTED PANEER PANINI</td>
          <td className="ft-Wt-700">260.00</td>
          <td className="ft-Wt-700">200 GMS</td>
        </tr>
        <tr>
          <td>CHEESE MELTED TANDOORI PANEER TIKKA PANINI S/W</td>
          <td className="ft-Wt-700">NA</td>
          <td className="ft-Wt-700">170 GMS</td>
        </tr>
        <tr>
          <td>CLASSIC MARGRITA PIZZA</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">7'inch</td>
        </tr>
        <tr>
          <td>PEPPY PANEER CHEESE BURST PIZZA</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">7'inch</td>
        </tr>
        <tr>
          <td>CHEESE CORN PIZZA</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">7'inch</td>
        </tr>
        <tr>
          <td>DOUBLE CHEESE TOMATO SANDWICH</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">200 GMS</td>
        </tr>
      </table>
    );
  },
  cafe3: () => {
    return (
      <>
      <table>
        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="title">
          <td colSpan={3}>RUCHI SAGAR BY RAJDHANI</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>NEW PRICE</td>
          <td>GM/ML</td>
        </tr>

        <tr>
          <td>HOT- FILTER KAAPI</td>
          <td className="ft-Wt-700">80.00</td>
          <td className="ft-Wt-700">90 ML</td>
        </tr>
        <tr>
          <td>BLACK FILTER KAAPI</td>
          <td className="ft-Wt-700">70.00</td>
          <td className="ft-Wt-700">90 ML</td>
        </tr>
        <tr>
          <td>REGULAR TEA</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">90 ML</td>
        </tr>
        <tr>
          <td>RUCHI SAGAR DABELI</td>
          <td className="ft-Wt-700">120.00</td>
          <td className="ft-Wt-700">200 GMS</td>
        </tr>
        <tr>
          <td>PARIPPU VADA (DAL WADA )</td>
          <td className="ft-Wt-700">120.00</td>
          <td className="ft-Wt-700">250 GMS</td>
        </tr>
        <tr>
          <td>SAMOSA 2 PCS</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">300 GMS</td>
        </tr>
        <tr>
          <td>GHEE PODI IDLI</td>
          <td className="ft-Wt-700">230.00</td>
          <td className="ft-Wt-700">230 GMS</td>
        </tr>
        <tr>
          <td>RUCHI SAGAR PAV BHAJI</td>
          <td className="ft-Wt-700">240.00</td>
          <td className="ft-Wt-700">250 GMS</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">COLD BEVERAGE</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>MY WATER BOX</td>
          <td className="ft-Wt-700">50.00</td>
          <td className="ft-Wt-700">500 ML</td>
        </tr>
        <tr>
          <td>KULUKKI SARBATH / NANNARI SHARBAT</td>
          <td className="ft-Wt-700">120.00</td>
          <td className="ft-Wt-700">300 ML</td>
        </tr>
        <tr>
          <td>NEER SHARBAT</td>
          <td className="ft-Wt-700">120.00</td>
          <td className="ft-Wt-700">300 ML</td>
        </tr>
      </table>
    </>
    );
  },
  cafe4: () => {
    return (
      <table>
      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="cafe-container">
        <td colSpan={9} className="cafe-logo">
          <img className="cafe-img" src={Dope} />
        </td>
      </tr>
      <tr className="title">
        <td colSpan={3}>DOPE COFFEE</td>
      </tr>
      <tr className="head">
        <td>MENU</td>
        <td>NEW PRICE</td>
        <td>GM/ML</td>
      </tr>

      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="spacer">
        <td className="ft-Wt-700">HOT BEVERAGE</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>AMERICANO</td>
        <td className="ft-Wt-700">250.00</td>
        <td className="ft-Wt-700">220ML</td>
      </tr>
      <tr>
        <td>CAPPUCCINO</td>
        <td className="ft-Wt-700">250.00</td>
        <td className="ft-Wt-700">220ML</td>
      </tr>
      <tr>
        <td>LATTE</td>
        <td className="ft-Wt-700">250.00</td>
        <td className="ft-Wt-700">220ML</td>
      </tr>
      <tr>
        <td>MOCHA</td>
        <td className="ft-Wt-700">250.00</td>
        <td className="ft-Wt-700">220ML</td>
      </tr>

      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="spacer">
        <td className="ft-Wt-700">ICED/COLD</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>ICED AMERICANO</td>
        <td className="ft-Wt-700">250.00</td>
        <td className="ft-Wt-700">220ML</td>
      </tr>
      <tr>
        <td>ICED LATTE</td>
        <td className="ft-Wt-700">250.00</td>
        <td className="ft-Wt-700">220ML</td>
      </tr>
      <tr>
        <td>COLD BREW</td>
        <td className="ft-Wt-700">250.00</td>
        <td className="ft-Wt-700">220ML</td>
      </tr>
      <tr>
        <td>DOPE'S COLD COFFEE</td>
        <td className="ft-Wt-700">250.00</td>
        <td className="ft-Wt-700">220ML</td>
      </tr>

      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="spacer">
        <td className="ft-Wt-700">TEA</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>GREEN TEA</td>
        <td className="ft-Wt-700">150.00</td>
        <td className="ft-Wt-700">180 ML</td>
      </tr>
      <tr>
        <td>GINGER TEA</td>
        <td className="ft-Wt-700">150.00</td>
        <td className="ft-Wt-700">180 ML</td>
      </tr>
      <tr>
        <td>MASALA CHAI</td>
        <td className="ft-Wt-700">150.00</td>
        <td className="ft-Wt-700">180 ML</td>
      </tr>

      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="spacer">
        <td className="ft-Wt-700">BEVERAGE ADD ONS (FLAVOURS)</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>CHOCOLATE/HAZELNUT/CARAMEL/VANILLA</td>
        <td className="ft-Wt-700">50.00</td>
        <td className="ft-Wt-700">15 ML</td>
      </tr>

      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="spacer">
        <td className="ft-Wt-700">EATS</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>BUTTER CROISSANT</td>
        <td className="ft-Wt-700">150.00</td>
        <td className="ft-Wt-700">100 GMS</td>
      </tr>
      <tr>
        <td>PAIN AU CHOCOLATE</td>
        <td className="ft-Wt-700">150.00</td>
        <td className="ft-Wt-700">120 GMS</td>
      </tr>
      <tr>
        <td>CHILLY CHEESE PANINI</td>
        <td className="ft-Wt-700">200.00</td>
        <td className="ft-Wt-700">200 GMS</td>
      </tr>
      <tr>
        <td>VEG PUFF</td>
        <td className="ft-Wt-700">120.00</td>
        <td className="ft-Wt-700">80 GMS</td>
      </tr>
      <tr>
        <td>CHEESE CROISSANT</td>
        <td className="ft-Wt-700">150.00</td>
        <td className="ft-Wt-700">80 GMS</td>
      </tr>
    </table>
    );
  },
  cafe5: () => {
    return (
      <>
      <table>
        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="cafe-container">
          <td colSpan={9} className="cafe-logo">
            <img className="cafe-img" src={highness} />
          </td>
        </tr>
        <tr className="title">
          <td colSpan={3}>HIGHNESS PANINIS</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>NEW PRICE</td>
          <td>GM/ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">SNACKS & BAKERY</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>MEXICAN PANINI (JAIN/REGULAR)</td>
          <td className="ft-Wt-700">230.00</td>
          <td className="ft-Wt-700">200 gms</td>
        </tr>
        <tr>
          <td>PANEER TIKKA PANINI (SANDWICH)</td>
          <td className="ft-Wt-700">230.00</td>
          <td className="ft-Wt-700">200 gms</td>
        </tr>
        <tr>
          <td>CHEESE MELT PANINI (JAIN/REGULAR)</td>
          <td className="ft-Wt-700">260.00</td>
          <td className="ft-Wt-700">250 gms</td>
        </tr>
        <tr>
          <td>CHEESE MAYO GARLIC BREAD</td>
          <td className="ft-Wt-700">230.00</td>
          <td className="ft-Wt-700">120 gms</td>
        </tr>
        <tr>
          <td>VEG GRILLED SANDWICH (JAIN/REGULAR)</td>
          <td className="ft-Wt-700">270.00</td>
          <td className="ft-Wt-700">280 gms</td>
        </tr>
        <tr>
          <td>MELTED SANDWICH (JAIN/REGULAR)</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">280 gms</td>
        </tr>
        <tr>
          <td>BUN MASKA</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">50 gms</td>
        </tr>
        <tr>
          <td>BUN JAM</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">50 gms</td>
        </tr>
        <tr>
          <td>CHEESE ALOO MASALA SANDWICH</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">250 gms</td>
        </tr>
        <tr>
          <td>BUN MASKA JAM</td>
          <td className="ft-Wt-700">120.00</td>
          <td className="ft-Wt-700">60gms</td>
        </tr>
        <tr>
          <td>CHEESE CHUTNEY SANDWICH</td>
          <td className="ft-Wt-700">220.00</td>
          <td className="ft-Wt-700">250 gms</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">ROLL</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>PANEER TIKKA ROLL*</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">200 GMS</td>
        </tr>
        <tr>
          <td>THE INDIAN BURRITO ROLL*</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">200 GMS</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">HOT BEVERAGES</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>REGULAR ADRAK TEA</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">100 ml</td>
        </tr>
        <tr>
          <td>MASALA TEA</td>
          <td className="ft-Wt-700">70.00</td>
          <td className="ft-Wt-700">100 ml</td>
        </tr>
        <tr>
          <td>BLACK TEA</td>
          <td className="ft-Wt-700">70.00</td>
          <td className="ft-Wt-700">100 ml</td>
        </tr>
        <tr>
          <td>LEMON TEA</td>
          <td className="ft-Wt-700">70.00</td>
          <td className="ft-Wt-700">100 ml</td>
        </tr>
        <tr>
          <td>GREEN TEA</td>
          <td className="ft-Wt-700">70.00</td>
          <td className="ft-Wt-700">100 ml</td>
        </tr>
        <tr>
          <td>CAPPUCCINO</td>
          <td className="ft-Wt-700">150.00</td>
          <td className="ft-Wt-700">200 ml</td>
        </tr>
        <tr>
          <td>FILTER COFFEE</td>
          <td className="ft-Wt-700">80.00</td>
          <td className="ft-Wt-700">100 ml</td>
        </tr>
        <tr>
          <td>CAFÉ AMERICANO</td>
          <td className="ft-Wt-700">150.00</td>
          <td className="ft-Wt-700">200 ml</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">COLD BEVERAGES</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>SIGNATURE MOCHA COLD COFFEE</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">300 ml</td>
        </tr>
        <tr>
          <td>SIGNATURE COLD COFFEE</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">300 ml</td>
        </tr>
        <tr>
          <td>LEMON ICE TEA</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">300 ml</td>
        </tr>
        <tr>
          <td>PEACH ICE TEA</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">300 ml</td>
        </tr>
        <tr>
          <td>SIGNATURE ICE AMERICANO</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">300 ml</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">PIZZA</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>MARGARITA PIZZA (JAIN/REGULAR)</td>
          <td className="ft-Wt-700">280.00</td>
          <td className="ft-Wt-700">140 gms</td>
        </tr>
        <tr>
          <td>PEPPY PANEER PIZZA (JAIN/REGULAR)</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">170 gms</td>
        </tr>
        <tr>
          <td>FARM HOUSE PIZZA (JAIN/REGULAR)</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">170 gms</td>
        </tr>
      </table>
    </>
    );
  },
  cafe6: () => {
    return (
      <>
      <table>
        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="cafe-container">
          <td colSpan={9} className="cafe-logo">
            <img className="cafe-img" src={"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRgh22zoNif1qEZXCCOA4-J-_fUflVFTgmigIb-VSzpZkbFcE-81ou9YXI&s=10"} />
          </td>
        </tr>
        <tr className="title">
          <td colSpan={3}>THIRD WAVE COFFEE</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>NEW PRICE</td>
          <td>GM/ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">HOT BEVERAGE & ICED</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>AMERICANO</td>
          <td className="ft-Wt-700">280.00</td>
          <td className="ft-Wt-700">240 ML</td>
        </tr>
        <tr>
          <td>CAPPUCCINO</td>
          <td className="ft-Wt-700">290.00</td>
          <td className="ft-Wt-700">240 ML</td>
        </tr>
        <tr>
          <td>LATTE</td>
          <td className="ft-Wt-700">290.00</td>
          <td className="ft-Wt-700">240 ML</td>
        </tr>
        <tr>
          <td>HOT CHOCOLATE</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">240 ML</td>
        </tr>
        <tr>
          <td>FLAT WHITE</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">240 ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">THIRD WAVE SPECIAL ICED/COLD</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>FRENCH VANILA LATTE</td>
          <td className="ft-Wt-700">400.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>
        <tr>
          <td>SEA SALT MOCHA</td>
          <td className="ft-Wt-700">400.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>
        <tr>
          <td>COLD COFFEE</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">TEAS</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>MASALA CHAI TEA LATTE</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">240ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">ICED TEA & COLD</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>CITEUS ICED TEA</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>
        <tr>
          <td>STRAWBERRY ICED TEA</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>
        <tr>
          <td>CLASSIC LEMONADE</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>
        <tr>
          <td>STRAWBERRY LEMONADE</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">ADD ON SYRUP</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>HAZELNUT</td>
          <td className="ft-Wt-700">40.00</td>
          <td className="ft-Wt-700">20 ML</td>
        </tr>
        <tr>
          <td>VANILA</td>
          <td className="ft-Wt-700">40.00</td>
          <td className="ft-Wt-700">20 ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">MILKSHAKES</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>CHOCOLICIOUS</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>
        <tr>
          <td>STRAWBERRY DRINK SHAKE</td>
          <td className="ft-Wt-700">400.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">FOOD</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>CHILLI CHEESE GARLIC TOAST</td>
          <td className="ft-Wt-700">360.00</td>
          <td className="ft-Wt-700">210 GMS</td>
        </tr>
        <tr>
          <td>CHOCOLATE CROISSANT</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">115 GMS</td>
        </tr>
        <tr>
          <td>MUSHROOM & CHEESE CROISSANT</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">115 GMS</td>
        </tr>
        <tr>
          <td>CLASSIC COREAN BURN</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">120 GMS</td>
        </tr>
        <tr>
          <td>GOCHUJANG COREAN BURN</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">120 GMS</td>
        </tr>
        <tr>
          <td>CHILLI PANEER CALZONE</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">115 GMS</td>
        </tr>
        <tr>
          <td>RICH HAZELNUT TRUFFLE CAKE</td>
          <td className="ft-Wt-700">370.00</td>
          <td className="ft-Wt-700">160 GMS</td>
        </tr>
        <tr>
          <td>BANANA WALNUT TEA CAKE</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">90 GMS</td>
        </tr>
        <tr>
          <td>PANEER CORN TOAST</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">215 GMS</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">OTHER ITEMS</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>ROASTED CASHEW</td>
          <td className="ft-Wt-700">160.00</td>
          <td className="ft-Wt-700">50 GMS</td>
        </tr>
        <tr>
          <td>ROASTED ALMOND</td>
          <td className="ft-Wt-700">160.00</td>
          <td className="ft-Wt-700">50 GMS</td>
        </tr>
        <tr>
          <td>ROASTED ALMOND CHOCOLATE BAR</td>
          <td className="ft-Wt-700">180.00</td>
          <td className="ft-Wt-700">50 GMS</td>
        </tr>
        <tr>
          <td>SALTED CARREMEL CHOCOLATE BAR</td>
          <td className="ft-Wt-700">180.00</td>
          <td className="ft-Wt-700">50 GMS</td>
        </tr>
      </table>
    </>
    );
  },
  cafe7: () => {
    return (
      <>
      <table>
        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="cafe-container">
          <td colSpan={9} className="cafe-logo">
            <img className="cafe-img" src={"https://i.pinimg.com/736x/bc/0a/c8/bc0ac814509d6cc49d5c0638f369317b.jpg"} />
          </td>
        </tr>
        <tr className="title">
          <td colSpan={3}>STARBUCKS</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
          <td>GM/ML</td>
        </tr>

        <tr>
          <td>CAPPUCCINO (HOT)</td>
          <td className="ft-Wt-700">310.00</td>
          <td className="ft-Wt-700">237 ml</td>
        </tr>
        <tr>
          <td>CAFFÉ LATTE (HOT)</td>
          <td className="ft-Wt-700">310.00</td>
          <td className="ft-Wt-700">237 ml</td>
        </tr>
        <tr>
          <td>FLAT WHITE (HOT)</td>
          <td className="ft-Wt-700">340.00</td>
          <td className="ft-Wt-700">237 ml</td>
        </tr>
        <tr>
          <td>AMERICANO (HOT)</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">237 ml</td>
        </tr>
        <tr>
          <td>CAFFÉ MOCHA (HOT)</td>
          <td className="ft-Wt-700">370.00</td>
          <td className="ft-Wt-700">237 ml</td>
        </tr>
        <tr>
          <td>CAFFÉ LATTE (ICED)</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">354 ml</td>
        </tr>
        <tr>
          <td>AMERICANO (ICED)</td>
          <td className="ft-Wt-700">330.00</td>
          <td className="ft-Wt-700">354 ml</td>
        </tr>
        <tr>
          <td>CAFFÉ MOCHA (ICED)</td>
          <td className="ft-Wt-700">400.00</td>
          <td className="ft-Wt-700">354 ml</td>
        </tr>
        <tr>
          <td>TALL COLD BREW BLACK</td>
          <td className="ft-Wt-700">360.00</td>
          <td className="ft-Wt-700">354 ml</td>
        </tr>
        <tr>
          <td>ICED TALL COLD BREW WITH GINGER ALE</td>
          <td className="ft-Wt-700">430.00</td>
          <td className="ft-Wt-700">354 ml</td>
        </tr>
        <tr>
          <td>TALL JAVA CHIP FRAPPUCCINO</td>
          <td className="ft-Wt-700">390.00</td>
          <td className="ft-Wt-700">354 ml</td>
        </tr>
        <tr>
          <td>TALL COLD COFFEE</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">354 ml</td>
        </tr>
        <tr>
          <td>PANEER TIKKA SANDWICH</td>
          <td className="ft-Wt-700">310.00</td>
          <td className="ft-Wt-700">180 grams</td>
        </tr>
        <tr>
          <td>SPINACH AND CORN SANDWICH</td>
          <td className="ft-Wt-700">290.00</td>
          <td className="ft-Wt-700">180 grams</td>
        </tr>
        <tr>
          <td>MASALA POTATO PUFF</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">100 grams</td>
        </tr>
        <tr>
          <td>VEG PROTEIN WRAP</td>
          <td className="ft-Wt-700">400.00</td>
          <td className="ft-Wt-700">200 grams</td>
        </tr>
        <tr>
          <td>TOFU & SPINACH CROISSANT</td>
          <td className="ft-Wt-700">380.00</td>
          <td className="ft-Wt-700">200 grams</td>
        </tr>
        <tr>
          <td>CHOCOLATE COOKIE</td>
          <td className="ft-Wt-700">310.00</td>
          <td className="ft-Wt-700">200 grams</td>
        </tr>
        <tr>
          <td>CHOCOLATE TRUFFLE</td>
          <td className="ft-Wt-700">430.00</td>
          <td className="ft-Wt-700">200 grams</td>
        </tr>
        <tr>
          <td>ROASTED ALMOND</td>
          <td className="ft-Wt-700">185.00</td>
          <td className="ft-Wt-700">50gm</td>
        </tr>
        <tr>
          <td>ROASTED CASHEW</td>
          <td className="ft-Wt-700">185.00</td>
          <td className="ft-Wt-700">50gm</td>
        </tr>
        <tr>
          <td>COATED CHOCOLATE ALMOND</td>
          <td className="ft-Wt-700">185.00</td>
          <td className="ft-Wt-700">50gm</td>
        </tr>
        <tr>
          <td>JUICES ABC</td>
          <td className="ft-Wt-700">280.00</td>
          <td className="ft-Wt-700">250ml</td>
        </tr>
        <tr>
          <td>JUICES ORANGE</td>
          <td className="ft-Wt-700">280.00</td>
          <td className="ft-Wt-700">250ml</td>
        </tr>
        <tr>
          <td>CHILLI CHEESE TOAST</td>
          <td className="ft-Wt-700">380.00</td>
          <td className="ft-Wt-700">200 GM</td>
        </tr>
      </table>
      <table>
        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        
        <tr className="title">
          <td colSpan={3}>RASOI RAGA</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>NEW PRICE</td>
          <td>GM/ML</td>
        </tr>

        <tr>
          <td>MASALA ALOO CHEESE ROLL</td>
          <td className="ft-Wt-700">230.00</td>
          <td className="ft-Wt-700">230 GMS</td>
        </tr>
        <tr>
          <td>PANEER KATHI ROLL</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">250 GMS</td>
        </tr>
        <tr>
          <td>CORN & CHEESE MASALA ROLL</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">230 GMS</td>
        </tr>
        <tr>
          <td>MUSHROOM GULISTAN ROLL</td>
          <td className="ft-Wt-700">280.00</td>
          <td className="ft-Wt-700">230 GMS</td>
        </tr>
        <tr>
          <td>PAHADI PANEER TIKKA ROLL</td>
          <td className="ft-Wt-700">280.00</td>
          <td className="ft-Wt-700">230 GMS</td>
        </tr>
        <tr>
          <td>SHAHI PANEER MAKHANI ROLL</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">230 GMS</td>
        </tr>
        <tr>
          <td>DAHI KE KABAB</td>
          <td className="ft-Wt-700">230.00</td>
          <td className="ft-Wt-700">180 GMS</td>
        </tr>
        <tr>
          <td>PERI PERI PANEER TIKKA</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">180 GMS</td>
        </tr>
        <tr>
          <td>CHOLE TIKKI CHAAT</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">250 GMS</td>
        </tr>
        <tr>
          <td>DAHI PAPDI CHAAT</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">200 GMS</td>
        </tr>
        <tr>
          <td>GOLGAPPA CHAAT</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">180 GMS</td>
        </tr>
        <tr>
          <td>RASOI RAGA VEG DUM BIRYANI</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">450 GMS</td>
        </tr>
        <tr>
          <td>MASALA CHAAS</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">250 ML</td>
        </tr>
        <tr>
          <td>LEMON ICED TEA</td>
          <td className="ft-Wt-700">130.00</td>
          <td className="ft-Wt-700">250 ML</td>
        </tr>
      </table>
      </>
    );
  },
  cafe8: () => {
    return (
      <table>
        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="cafe-container">
          <td colSpan={9} className="cafe-logo">
            <img className="cafe-img" src={highness} />
          </td>
        </tr>
        <tr className="title">
          <td colSpan={3}>HIGHNESS PANINI - Hall 4</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>NEW PRICE</td>
          <td>GM/ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">SNACKS & BAKERY</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>MEXICAN PANINI (JAIN/REGULAR)</td>
          <td className="ft-Wt-700">230.00</td>
          <td className="ft-Wt-700">200 gms</td>
        </tr>
        <tr>
          <td>PANEER TIKKA PANINI (SANDWICH)</td>
          <td className="ft-Wt-700">230.00</td>
          <td className="ft-Wt-700">200 gms</td>
        </tr>
        <tr>
          <td>CHEESE MELT PANINI (JAIN/REGULAR)</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">250 gms</td>
        </tr>
        <tr>
          <td>CHEESE MAYO GARLIC BREAD</td>
          <td className="ft-Wt-700">230.00</td>
          <td className="ft-Wt-700">120 gms</td>
        </tr>
        <tr>
          <td>VEG GRILLED SANDWICH (JAIN/REGULAR)</td>
          <td className="ft-Wt-700">270.00</td>
          <td className="ft-Wt-700">280 gms</td>
        </tr>
        <tr>
          <td>MELTED SANDWICH (JAIN/REGULAR)</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">280 gms</td>
        </tr>
        <tr>
          <td>CHEESE ALOO MASALA SANDWICH</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">250 gms</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">ROLL</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>PANEER TIKKA ROLL</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">150 gms</td>
        </tr>
        <tr>
          <td>SOYA BEAN ROLL</td>
          <td className="ft-Wt-700">-</td>
          <td className="ft-Wt-700">150 gms</td>
        </tr>
        <tr>
          <td>THE INDIAN BURRITO ROLL</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">200 GMS</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">PIZZA</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>MARGARITA PIZZA (JAIN/REGULAR)</td>
          <td className="ft-Wt-700">280.00</td>
          <td className="ft-Wt-700">140 gms</td>
        </tr>
        <tr>
          <td>PEPPY PANEER PIZZA (JAIN/REGULAR)</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">170 gms</td>
        </tr>
        <tr>
          <td>FARM HOUSE PIZZA (JAIN/REGULAR)</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">170 gms</td>
        </tr>
      </table>
    );
  },
  cafe9: () => {
    return (
      <table>
        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="cafe-container">
          <td colSpan={9} className="cafe-logo">
            <img className="cafe-img" src={ny} />
          </td>
        </tr>
        <tr className="title">
          <td colSpan={3}>NEW YORK BURRITO</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>NEW PRICE</td>
          <td>GM/ML</td>
        </tr>
        <tr>
          <td>MEXICAN BOWL</td>
          <td className="ft-Wt-700">330.00</td>
          <td className="ft-Wt-700">250 Gms</td>
        </tr>
        <tr>
          <td>MEXICAN BURRITO</td>
          <td className="ft-Wt-700">330.00</td>
          <td className="ft-Wt-700">250 Gms</td>
        </tr>
        <tr>
          <td>MEXICAN PIZZA</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">250 Gms</td>
        </tr>
        <tr>
          <td>HARDSHELL TACOS(3 PC)</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">160 Gms</td>
        </tr>
        <tr>
          <td>REGULAR NACHOS</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">180 Gms</td>
        </tr>
        <tr>
          <td>SUPER NACHOS</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">250 Gms</td>
        </tr>
        <tr>
          <td>GUACAMOLE BURGER</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">220 Gms</td>
        </tr>
        <tr>
          <td>QUESADILLA (3 PCS)</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">250 Gms</td>
        </tr>
        <tr>
          <td>MEXICAN RICE</td>
          <td className="ft-Wt-700">150.00</td>
          <td className="ft-Wt-700">140 Gms</td>
        </tr>
        <tr>
          <td>HIBISCUS MINT</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">250 ML</td>
        </tr>
        <tr>
          <td>CUCUMBER MINT</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">250 ML</td>
        </tr>
        <tr>
          <td>DRAGON FRUIT</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">250 ML</td>
        </tr>
        <tr>
          <td>ICE TEA(COLD)</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">250 ML</td>
        </tr>
        <tr>
          <td>MEXICAN PANINI</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">220 Gms</td>
        </tr>
        <tr>
          <td>CHURROS</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">80 Gms</td>
        </tr>
        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>TEX MEX/PANEER</td>
          <td className="ft-Wt-700">50.00</td>
          <td className="ft-Wt-700">40 Gms</td>
        </tr>
        <tr>
          <td>CHEESE SAUCE/SOUR CREAM</td>
          <td className="ft-Wt-700">50.00</td>
          <td className="ft-Wt-700">40 Gms</td>
        </tr>
        <tr>
          <td>GUACAMOLE</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">40 Gms</td>
        </tr>
        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>CRANBERRY ALMOND ENERGY BAR</td>
          <td className="ft-Wt-700">50.00</td>
          <td className="ft-Wt-700">32 Gm</td>
        </tr>
        <tr>
          <td>ORANGE DATES ALMOND ENERGY BAR</td>
          <td className="ft-Wt-700">50.00</td>
          <td className="ft-Wt-700">32 Gm</td>
        </tr>
        <tr>
          <td>7 NUTS &SEEDS ENERGY BAR</td>
          <td className="ft-Wt-700">50.00</td>
          <td className="ft-Wt-700">32 Gm</td>
        </tr>
        <tr>
          <td>CHOCOLATE BROWNIES ALMOND ENERGY BAR</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">32 Gm</td>
        </tr>
        <tr>
          <td>CALIFORNIA PISTACHIO ENERGY BAR</td>
          <td className="ft-Wt-700">150.00</td>
          <td className="ft-Wt-700">32 Gm</td>
        </tr>
      </table>
    );
  },

  cafe10: () => {
    return (
     <>
      <table>
        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="cafe-container">
          <td colSpan={9} className="cafe-logo">
            <img className="cafe-img" src={society} />
          </td>
        </tr>
        <tr className="title">
          <td colSpan={3}>SOCIETY TEA TERMINAL</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
          <td>GM / ML</td>
        </tr>

        <tr>
          <td>REGULER TEA</td>
          <td className="ft-Wt-700">50.00</td>
          <td className="ft-Wt-700">100 ML</td>
        </tr>
        <tr>
          <td>MASALA TEA</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">100 ML</td>
        </tr>
        <tr>
          <td>ELAICHI TEA</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">100 ML</td>
        </tr>
        <tr>
          <td>CAPPUCCINO</td>
          <td className="ft-Wt-700">80.00</td>
          <td className="ft-Wt-700">100ML</td>
        </tr>
        <tr>
          <td>COLD COFFEE</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">250ML</td>
        </tr>
        <tr>
          <td>KHARI (3 PCS )</td>
          <td className="ft-Wt-700">40.00</td>
          <td className="ft-Wt-700">20GMS</td>
        </tr>
        <tr>
          <td>TOAST ( 3 PCS )</td>
          <td className="ft-Wt-700">40.00</td>
          <td className="ft-Wt-700">20GMS</td>
        </tr>
        <tr>
          <td>BUN MASKA</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">1 PCS</td>
        </tr>
        <tr>
          <td>CLEANSE</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">100ML</td>
        </tr>
        <tr>
          <td>POHA</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">60GMS</td>
        </tr>
        <tr>
          <td>UPMA</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">60GMS</td>
        </tr>
        <tr>
          <td>BLACK COFFEE</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">100ML</td>
        </tr>
        <tr>
          <td>MAGGI</td>
          <td className="ft-Wt-700">70.00</td>
          <td className="ft-Wt-700">60GMS</td>
        </tr>
        <tr>
          <td>HALDI DOODH</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">100ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">RTD ICED TEA</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>PEACH & APRICOT</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">250 ML</td>
        </tr>
        <tr>
          <td>LEMON</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">250 ML</td>
        </tr>
        <tr>
          <td>GINGER CINNAMON BERGAMOT</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">250 ML</td>
        </tr>
        <tr>
          <td>CAMAMILE JASMINE</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">250 ML</td>
        </tr>
        <tr>
          <td>2 BOTTEL ANY FLAVOUR</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">500 ML</td>
        </tr>
        <tr>
          <td>4 BOTTEL ANY FLAVOUR</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">1000 ML</td>
        </tr>
        <tr>
          <td>STRAWBERRY KIWI LEMONGRASS</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">250 ML</td>
        </tr>
        <tr>
          <td>ORANGE GINGER LEMONGRASS</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">250 ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">DETOX SERIES</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>GREEN TEA</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">200ML</td>
        </tr>
        <tr>
          <td>KASMIRI KAHWA</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">200ML</td>
        </tr>
        <tr>
          <td>TULSI RITUAL</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">200ML</td>
        </tr>
        <tr>
          <td>MOROCCAN MINT</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">200ML</td>
        </tr>
        <tr>
          <td>FLOWERY BOUQUET</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">200ML</td>
        </tr>
        <tr>
          <td>SOOTHING CHAMOMILE</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">200ML</td>
        </tr>
        <tr>
          <td>DIVINE DARJEELING</td>
          <td className="ft-Wt-700">60.00</td>
          <td className="ft-Wt-700">200ML</td>
        </tr>
        <tr>
          <td>2 Bottle any flavour</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">250ML</td>
        </tr>
        <tr>
          <td>4 Bottle any flavour</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">250ML</td>
        </tr>
      </table>
      <table>
      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="cafe-container">
        <td colSpan={9} className="cafe-logo">
          <img className="cafe-img" src={tibbs} />
        </td>
      </tr>
      <tr class="title">
        <td colspan="6">TIBBS FRANKIE</td>
      </tr>
      <tr class="head">
        <td colspan="3">MENU</td>
        <td>NEW PRICE</td>
        <td>GM/ML</td>
      </tr>
      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>

      <tr className="spacer">
        <td className="ft-Wt-700">VEG FRANKIE</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td colSpan={3}>CLASSIC VEG</td>
        <td className="ft-Wt-700">200.00</td>
        <td className="ft-Wt-700">200 GMS</td>
      </tr>

      <tr>
        <td colSpan={3}>VEG SCHEZWAN</td>
        <td className="ft-Wt-700">220.00</td>
        <td className="ft-Wt-700">200 GMS</td>
      </tr>

      <tr>
        <td colSpan={3}>VEG CHEESE JELAPENO</td>
        <td className="ft-Wt-700">220.00</td>
        <td className="ft-Wt-700">200 GMS</td>
      </tr>

      <tr>
        <td colSpan={3}>JAIN ROLL</td>
        <td className="ft-Wt-700">220.00</td>
        <td className="ft-Wt-700">200 GMS</td>
      </tr>

      <tr>
        <td colSpan={3}>TAWA PANEER</td>
        <td className="ft-Wt-700">230.00</td>
        <td className="ft-Wt-700">200 GMS</td>
      </tr>

      <tr>
        <td colSpan={3}>CHILLY PANEER</td>
        <td className="ft-Wt-700">230.00</td>
        <td className="ft-Wt-700">200 GMS</td>
      </tr>

      <tr>
        <td colSpan={3}>EXTRA CHEESE</td>
        <td className="ft-Wt-700">50.00</td>
        <td className="ft-Wt-700">20 GMS</td>
      </tr>

      <tr>
        <td colSpan={3}>EXTRA CHIPOTLE SAUCE</td>
        <td className="ft-Wt-700">50.00</td>
        <td className="ft-Wt-700">50 GMS</td>
      </tr>

      <tr>
        <td colSpan={3}>EXTRA TANDOORI SAUCE</td>
        <td className="ft-Wt-700">50.00</td>
        <td className="ft-Wt-700">50 GMS</td>
      </tr>

      <tr>
        <td colSpan={3}>SHIKANJI</td>
        <td className="ft-Wt-700">60.00</td>
        <td className="ft-Wt-700">300 ML</td>
      </tr>

      <tr>
        <td colSpan={3}>GOOEY BROWNIE</td>
        <td className="ft-Wt-700">140.00</td>
        <td className="ft-Wt-700">90 GMS</td>
      </tr>

      <tr>
        <td colSpan={3}>AAM PANNA</td>
        <td className="ft-Wt-700">60.00</td>
        <td className="ft-Wt-700">300 ML</td>
      </tr>

      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="spacer">
        <td className="ft-Wt-700">PROTIROTI</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td colSpan={3}>PROTIROTI - CHETTINAD SUKHA SOYA CHAAP ROLL</td>
        <td className="ft-Wt-700">240.00</td>
        <td className="ft-Wt-700">200 GMS</td>
      </tr>

      <tr>
        <td colSpan={3}>PROTIROTI - BHUNA SOYA CHAAP ROLL</td>
        <td className="ft-Wt-700">240.00</td>
        <td className="ft-Wt-700">200 GMS</td>
      </tr>
    </table>
     </>
    );
  },

  cafe11: () => {
    return (
      <table>
      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="cafe-container">
        <td colSpan={9} className="cafe-logo">
          <img className="cafe-img" src={pizzeria} />
        </td>
      </tr>
      <tr class="title">
        <td colspan="6">PIZZERIA 1441</td>
      </tr>
      <tr class="head">
        <td colspan="3">MENU</td>
        <td>PRICE</td>
        <td>GM/ML</td>
      </tr>
      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>

      <tr className="spacer">
        <td className="ft-Wt-700">STARTERS</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td colSpan={3}>CLASSIC FRENCH FRIES</td>
        <td className="ft-Wt-700">150.00</td>
        <td className="ft-Wt-700">150 gms</td>
      </tr>

      <tr>
        <td colSpan={3}>PERI PERI FRIES</td>
        <td className="ft-Wt-700">200.00</td>
        <td className="ft-Wt-700">150 gms</td>
      </tr>

      <tr>
        <td colSpan={3}>GARLIC BREAD WITH CHEESY DIP</td>
        <td className="ft-Wt-700">150.00</td>
        <td className="ft-Wt-700">3 pcs</td>
      </tr>

      <tr>
        <td colSpan={3}>CHEESE GARLIC BREAD</td>
        <td className="ft-Wt-700">200.00</td>
        <td className="ft-Wt-700">3 pcs</td>
      </tr>
      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="spacer">
        <td className="ft-Wt-700">PIZZAS BY SLICE</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td colSpan={3}>MARGHERITA SLICE</td>
        <td className="ft-Wt-700">200.00</td>
        <td className="ft-Wt-700">5.5 inch</td>
      </tr>

      <tr>
        <td colSpan={3}>FARM FRESH PIZZA</td>
        <td className="ft-Wt-700">250.00</td>
        <td className="ft-Wt-700">5.5 inch</td>
      </tr>

      <tr>
        <td colSpan={3}>PANEER TIKKA PIZZA</td>
        <td className="ft-Wt-700">250.00</td>
        <td className="ft-Wt-700">5.5 inch</td>
      </tr>
      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="spacer">
        <td className="ft-Wt-700">PASTAS</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td colSpan={3}>ALFREDO PASTA VEG</td>
        <td className="ft-Wt-700">200.00</td>
        <td className="ft-Wt-700">200 gms</td>
      </tr>

      <tr>
        <td colSpan={3}>PINK SAUCE PASTA VEG</td>
        <td className="ft-Wt-700">200.00</td>
        <td className="ft-Wt-700">200 gms</td>
      </tr>
      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="spacer">
        <td className="ft-Wt-700">WRAPS</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td colSpan={3}>PERI PERI PANEER WRAP</td>
        <td className="ft-Wt-700">250.00</td>
        <td className="ft-Wt-700">200 gms</td>
      </tr>
      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="spacer">
        <td className="ft-Wt-700">BEVERAGES</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td colSpan={3}>MASALA LEMONADE</td>
        <td className="ft-Wt-700">150.00</td>
        <td className="ft-Wt-700">200 ml</td>
      </tr>

      <tr>
        <td colSpan={3}>LEMON ICED TEA</td>
        <td className="ft-Wt-700">150.00</td>
        <td className="ft-Wt-700">200 ml</td>
      </tr>
      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="spacer">
        <td className="ft-Wt-700">DESSERT</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td colSpan={3}>TIRAMISU</td>
        <td className="ft-Wt-700">150.00</td>
        <td className="ft-Wt-700">70 gms</td>
      </tr>
      <tr className="spacer">
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr className="spacer">
        <td className="ft-Wt-700">WATER</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td colSpan={3}>MY WATER BOX 500ML</td>
        <td className="ft-Wt-700">25.00</td>
        <td className="ft-Wt-700">500 ml</td>
      </tr>
    </table>
    );
  },
  cafe12: () => {
    return (
      <table>
        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="cafe-container">
          <td colSpan={9} className="cafe-logo">
            <img className="cafe-img" src={subway} />
          </td>
        </tr>
        <tr className="title">
          <td colSpan={3}>SUBWAY</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>NEW PRICE</td>
          <td>GM/ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">SANDWICHES</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>VEGGIE DELITE</td>
          <td className="ft-Wt-700">280.00</td>
          <td className="ft-Wt-700">220 GM</td>
        </tr>
        <tr>
          <td>ALOO PATTY</td>
          <td className="ft-Wt-700">320.00</td>
          <td className="ft-Wt-700">275 GM</td>
        </tr>
        <tr>
          <td>PANEER TIKKA</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">240 GM</td>
        </tr>
        <tr>
          <td>VEG SHAMMI</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">250 GM</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">SALADS</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>VEGGIE DELITE</td>
          <td className="ft-Wt-700">330.00</td>
          <td className="ft-Wt-700">365 GMS</td>
        </tr>
        <tr>
          <td>PANEER TIKKA</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">425 GMS</td>
        </tr>
        <tr>
          <td>ALOO PATTY</td>
          <td className="ft-Wt-700">330.00</td>
          <td className="ft-Wt-700">420 GMS</td>
        </tr>
        <tr>
          <td>VEG SHAMMI</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">425 GMS</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">WRAPS</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>VEGGIE DELITE</td>
          <td className="ft-Wt-700">330.00</td>
          <td className="ft-Wt-700">334 GMS</td>
        </tr>
        <tr>
          <td>PANEER TIKKA</td>
          <td className="ft-Wt-700">380.00</td>
          <td className="ft-Wt-700">350 GMS</td>
        </tr>
        <tr>
          <td>ALOO PATTY</td>
          <td className="ft-Wt-700">380.00</td>
          <td className="ft-Wt-700">350 GMS</td>
        </tr>
        <tr>
          <td>VEG SHAMMI</td>
          <td className="ft-Wt-700">380.00</td>
          <td className="ft-Wt-700">250 GMS</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">COLD BEVERAGES</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>COLD COFFEE</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">195 ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">COOKIES</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>DOUBLE DARK CHUNK</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">40 GMS</td>
        </tr>
        <tr>
          <td>DARK CHUNK</td>
          <td className="ft-Wt-700">100.00</td>
          <td className="ft-Wt-700">40 GMS</td>
        </tr>
        <tr>
          <td>MY WATER BOX 500ML</td>
          <td className="ft-Wt-700">50.00</td>
          <td className="ft-Wt-700">500 ML</td>
        </tr>
      </table>
    );
  },

  cafe13: () => {
    return (
      <>
      <table>
        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="cafe-container">
          <td colSpan={9} className="cafe-logo">
            <img className="cafe-img" src={"https://i.pinimg.com/736x/bc/0a/c8/bc0ac814509d6cc49d5c0638f369317b.jpg"} />
          </td>
        </tr>
        <tr className="title">
          <td colSpan={3}>STARBUCKS</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
          <td>GM/ML</td>
        </tr>

        <tr>
          <td>CAPPUCCINO (HOT)</td>
          <td className="ft-Wt-700">310.00</td>
          <td className="ft-Wt-700">237 ml</td>
        </tr>
        <tr>
          <td>CAFFÉ LATTE (HOT)</td>
          <td className="ft-Wt-700">310.00</td>
          <td className="ft-Wt-700">237 ml</td>
        </tr>
        <tr>
          <td>FLAT WHITE (HOT)</td>
          <td className="ft-Wt-700">340.00</td>
          <td className="ft-Wt-700">237 ml</td>
        </tr>
        <tr>
          <td>AMERICANO (HOT)</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">237 ml</td>
        </tr>
        <tr>
          <td>CAFFÉ MOCHA (HOT)</td>
          <td className="ft-Wt-700">370.00</td>
          <td className="ft-Wt-700">237 ml</td>
        </tr>
        <tr>
          <td>CAFFÉ LATTE (ICED)</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">354 ml</td>
        </tr>
        <tr>
          <td>AMERICANO (ICED)</td>
          <td className="ft-Wt-700">330.00</td>
          <td className="ft-Wt-700">354 ml</td>
        </tr>
        <tr>
          <td>CAFFÉ MOCHA (ICED)</td>
          <td className="ft-Wt-700">400.00</td>
          <td className="ft-Wt-700">354 ml</td>
        </tr>
        <tr>
          <td>TALL COLD BREW BLACK</td>
          <td className="ft-Wt-700">360.00</td>
          <td className="ft-Wt-700">354 ml</td>
        </tr>
        <tr>
          <td>ICED TALL COLD BREW WITH GINGER ALE</td>
          <td className="ft-Wt-700">430.00</td>
          <td className="ft-Wt-700">354 ml</td>
        </tr>
        <tr>
          <td>TALL JAVA CHIP FRAPPUCCINO</td>
          <td className="ft-Wt-700">390.00</td>
          <td className="ft-Wt-700">354 ml</td>
        </tr>
        <tr>
          <td>TALL COLD COFFEE</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">354 ml</td>
        </tr>
        <tr>
          <td>PANEER TIKKA SANDWICH</td>
          <td className="ft-Wt-700">310.00</td>
          <td className="ft-Wt-700">180 grams</td>
        </tr>
        <tr>
          <td>SPINACH AND CORN SANDWICH</td>
          <td className="ft-Wt-700">290.00</td>
          <td className="ft-Wt-700">180 grams</td>
        </tr>
        <tr>
          <td>MASALA POTATO PUFF</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">100 grams</td>
        </tr>
        <tr>
          <td>VEG PROTEIN WRAP</td>
          <td className="ft-Wt-700">400.00</td>
          <td className="ft-Wt-700">200 grams</td>
        </tr>
        <tr>
          <td>TOFU & SPINACH CROISSANT</td>
          <td className="ft-Wt-700">380.00</td>
          <td className="ft-Wt-700">200 grams</td>
        </tr>
        <tr>
          <td>CHOCOLATE COOKIE</td>
          <td className="ft-Wt-700">310.00</td>
          <td className="ft-Wt-700">200 grams</td>
        </tr>
        <tr>
          <td>CHOCOLATE TRUFFLE</td>
          <td className="ft-Wt-700">430.00</td>
          <td className="ft-Wt-700">200 grams</td>
        </tr>
        <tr>
          <td>ROASTED ALMOND</td>
          <td className="ft-Wt-700">185.00</td>
          <td className="ft-Wt-700">50gm</td>
        </tr>
        <tr>
          <td>ROASTED CASHEW</td>
          <td className="ft-Wt-700">185.00</td>
          <td className="ft-Wt-700">50gm</td>
        </tr>
        <tr>
          <td>COATED CHOCOLATE ALMOND</td>
          <td className="ft-Wt-700">185.00</td>
          <td className="ft-Wt-700">50gm</td>
        </tr>
        <tr>
          <td>JUICES ABC</td>
          <td className="ft-Wt-700">280.00</td>
          <td className="ft-Wt-700">250ml</td>
        </tr>
        <tr>
          <td>JUICES ORANGE</td>
          <td className="ft-Wt-700">280.00</td>
          <td className="ft-Wt-700">250ml</td>
        </tr>
        <tr>
          <td>CHILLI CHEESE TOAST</td>
          <td className="ft-Wt-700">380.00</td>
          <td className="ft-Wt-700">200 GM</td>
        </tr>
      </table>
      </>
    );
  },
  cafe14: () => {
    return (
      <table>
        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="cafe-container">
          <td colSpan={9} className="cafe-logo">
            <img className="cafe-img" src={"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRgh22zoNif1qEZXCCOA4-J-_fUflVFTgmigIb-VSzpZkbFcE-81ou9YXI&s=10"} />
          </td>
        </tr>
        <tr className="title">
          <td colSpan={3}>THIRD WAVE COFFEE</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>NEW PRICE</td>
          <td>GM/ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">HOT BEVERAGE & ICED</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>AMERICANO</td>
          <td className="ft-Wt-700">280.00</td>
          <td className="ft-Wt-700">240 ML</td>
        </tr>
        <tr>
          <td>CAPPUCCINO</td>
          <td className="ft-Wt-700">290.00</td>
          <td className="ft-Wt-700">240 ML</td>
        </tr>
        <tr>
          <td>LATTE</td>
          <td className="ft-Wt-700">290.00</td>
          <td className="ft-Wt-700">240 ML</td>
        </tr>
        <tr>
          <td>HOT CHOCOLATE</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">240 ML</td>
        </tr>
        <tr>
          <td>FLAT WHITE</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">240 ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">THIRD WAVE SPECIAL ICED/COLD</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>FRENCH VANILA LATTE</td>
          <td className="ft-Wt-700">400.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>
        <tr>
          <td>SEA SALT MOCHA</td>
          <td className="ft-Wt-700">400.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>
        <tr>
          <td>COLD COFFEE</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">TEAS</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>MASALA CHAI TEA LATTE</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">240ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">ICED TEA & COLD</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>CITEUS ICED TEA</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>
        <tr>
          <td>STRAWBERRY ICED TEA</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>
        <tr>
          <td>CLASSIC LEMONADE</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>
        <tr>
          <td>STRAWBERRY LEMONADE</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">ADD ON SYRUP</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>HAZELNUT</td>
          <td className="ft-Wt-700">40.00</td>
          <td className="ft-Wt-700">20 ML</td>
        </tr>
        <tr>
          <td>VANILA</td>
          <td className="ft-Wt-700">40.00</td>
          <td className="ft-Wt-700">20 ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">MILKSHAKES</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>CHOCOLICIOUS</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>
        <tr>
          <td>STRAWBERRY DRINK SHAKE</td>
          <td className="ft-Wt-700">400.00</td>
          <td className="ft-Wt-700">360 ML</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">FOOD</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>CHILLI CHEESE GARLIC TOAST</td>
          <td className="ft-Wt-700">360.00</td>
          <td className="ft-Wt-700">210 GMS</td>
        </tr>
        <tr>
          <td>CHOCOLATE CROISSANT</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">115 GMS</td>
        </tr>
        <tr>
          <td>MUSHROOM & CHEESE CROISSANT</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">115 GMS</td>
        </tr>
        <tr>
          <td>CLASSIC COREAN BURN</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">120 GMS</td>
        </tr>
        <tr>
          <td>GOCHUJANG COREAN BURN</td>
          <td className="ft-Wt-700">300.00</td>
          <td className="ft-Wt-700">120 GMS</td>
        </tr>
        <tr>
          <td>CHILLI PANEER CALZONE</td>
          <td className="ft-Wt-700">200.00</td>
          <td className="ft-Wt-700">115 GMS</td>
        </tr>
        <tr>
          <td>RICH HAZELNUT TRUFFLE CAKE</td>
          <td className="ft-Wt-700">370.00</td>
          <td className="ft-Wt-700">160 GMS</td>
        </tr>
        <tr>
          <td>BANANA WALNUT TEA CAKE</td>
          <td className="ft-Wt-700">250.00</td>
          <td className="ft-Wt-700">90 GMS</td>
        </tr>
        <tr>
          <td>PANEER CORN TOAST</td>
          <td className="ft-Wt-700">350.00</td>
          <td className="ft-Wt-700">215 GMS</td>
        </tr>

        <tr className="spacer">
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="spacer">
          <td className="ft-Wt-700">OTHER ITEMS</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>ROASTED CASHEW</td>
          <td className="ft-Wt-700">160.00</td>
          <td className="ft-Wt-700">50 GMS</td>
        </tr>
        <tr>
          <td>ROASTED ALMOND</td>
          <td className="ft-Wt-700">160.00</td>
          <td className="ft-Wt-700">50 GMS</td>
        </tr>
        <tr>
          <td>ROASTED ALMOND CHOCOLATE BAR</td>
          <td className="ft-Wt-700">180.00</td>
          <td className="ft-Wt-700">50 GMS</td>
        </tr>
        <tr>
          <td>SALTED CARREMEL CHOCOLATE BAR</td>
          <td className="ft-Wt-700">180.00</td>
          <td className="ft-Wt-700">50 GMS</td>
        </tr>
      </table>
    );
  },

  cafe15: () => {
    return (
      <>
        <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTwZGQb-y4ysQhUVAtiLDrmJ3Wxp-bRQlR-p4YSIp-y5LNso0XaIbENGv-G&s=10'} />
            </td>
          </tr>
          <tr className="title">
            <td colSpan={3}>SANDWIZZA</td>
          </tr>
          <tr className="head">
            <td>MENU</td>
            <td>NEW PRICE</td>
            <td>GM/ML</td>
          </tr>

          <tr>
            <td>VEGGIE MAYO SANDWICH</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">200GMS</td>
          </tr>
          <tr>
            <td>VEGGIE MAYO TOAST</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">210GMS</td>
          </tr>
          <tr>
            <td>SPINACH CORN TOAST</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">200GMS</td>
          </tr>
          <tr>
            <td>CHEESE MASALA TOAST</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">175GMS</td>
          </tr>
          <tr>
            <td>CHOCOLATE WALNUT TOAST</td>
            <td className="ft-Wt-700">NA</td>
            <td className="ft-Wt-700">180GMS</td>
          </tr>
          <tr>
            <td>HOT CHILLI GARLIC TOAST</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">180GMS</td>
          </tr>
          <tr>
            <td>CHEESE CHILLI TOAST</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">175GMS</td>
          </tr>
          <tr>
            <td>VEG CHEESE GRILL</td>
            <td className="ft-Wt-700">350.00</td>
            <td className="ft-Wt-700">520 GMS</td>
          </tr>
          <tr>
            <td>PANEER MAKHANI GRILL</td>
            <td className="ft-Wt-700">350.00</td>
            <td className="ft-Wt-700">430 GMS</td>
          </tr>
          <tr>
            <td>ACTIVITY TOAST</td>
            <td className="ft-Wt-700">170.00</td>
            <td className="ft-Wt-700">200 GMS</td>
          </tr>
          <tr>
            <td>VEG GRILL</td>
            <td className="ft-Wt-700">300.00</td>
            <td className="ft-Wt-700">NA</td>
          </tr>
          <tr>
            <td>MINT MOJITO</td>
            <td className="ft-Wt-700">180.00</td>
            <td className="ft-Wt-700">300ML</td>
          </tr>
          <tr>
            <td>LEMON ICE TEA</td>
            <td className="ft-Wt-700">170.00</td>
            <td className="ft-Wt-700">300ML</td>
          </tr>
          <tr>
            <td>PEACH ICE TEA</td>
            <td className="ft-Wt-700">170.00</td>
            <td className="ft-Wt-700">300ML</td>
          </tr>
          <tr>
            <td>GREEN APPLE MOJITO</td>
            <td className="ft-Wt-700">180.00</td>
            <td className="ft-Wt-700">300ML</td>
          </tr>
        </table>

        <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
         
          <tr className="title">
            <td colSpan={3}>CAFÉ BREWZ</td>
          </tr>
          <tr className="head">
            <td>MENU</td>
            <td>NEW PRICE</td>
            <td>GM/ML</td>
          </tr>

          <tr>
            <td>CAPPUCINNO</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">250 ml</td>
          </tr>
          <tr>
            <td>CAFÉ LATTE</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">250 ml</td>
          </tr>
          <tr>
            <td>CAFÉ MOCHA</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">250 ml</td>
          </tr>
          <tr>
            <td>AMERICANO</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">250 ml</td>
          </tr>
          <tr>
            <td>HOT CHOCOLATE</td>
            <td className="ft-Wt-700">180.00</td>
            <td className="ft-Wt-700">250 ml</td>
          </tr>
          <tr>
            <td>MASALA TEA</td>
            <td className="ft-Wt-700">60.00</td>
            <td className="ft-Wt-700">110 ml</td>
          </tr>
          <tr>
            <td>GREEN TEA</td>
            <td className="ft-Wt-700">70.00</td>
            <td className="ft-Wt-700">150 ml</td>
          </tr>
          <tr>
            <td>COLD COFFEE</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">300 ML</td>
          </tr>
          <tr>
            <td>ICE CHOCOLATE</td>
            <td className="ft-Wt-700">170.00</td>
            <td className="ft-Wt-700">300 ML</td>
          </tr>
          <tr>
            <td>ICE MOCHA</td>
            <td className="ft-Wt-700">250.00</td>
            <td className="ft-Wt-700">300 ML</td>
          </tr>
          <tr>
            <td>ICE AMERICANO</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">300 ML</td>
          </tr>
        </table>
      </>
    );
  },

  cafe16: () => {
    return (
      <>
        <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
         
          <tr className="title">
            <td colSpan={3}>NORTH PAVILLION</td>
          </tr>
          <tr className="head">
            <td>MENU</td>
            <td>NEW PRICE</td>
            <td>GM/ML</td>
          </tr>

          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="spacer">
            <td className="ft-Wt-700">COMBOS</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>CHHOLE -KULCHE (2PC)</td>
            <td className="ft-Wt-700">250.00</td>
            <td className="ft-Wt-700">260 GMS</td>
          </tr>
          <tr>
            <td>CHHOLE -ALOO PARATHA (2PC)</td>
            <td className="ft-Wt-700">260.00</td>
            <td className="ft-Wt-700">300 GMS</td>
          </tr>
          <tr>
            <td>CHHOLE - TAWA CHAPATI ( 3 PC )</td>
            <td className="ft-Wt-700">250.00</td>
            <td className="ft-Wt-700">290 GMS</td>
          </tr>
          <tr>
            <td>CHHOLE -STEAM RICE</td>
            <td className="ft-Wt-700">250.00</td>
            <td className="ft-Wt-700">400 GMS</td>
          </tr>
          <tr>
            <td>PANEER BUTTER MASALA +TAWA CHAPATI (3PC)</td>
            <td className="ft-Wt-700">280.00</td>
            <td className="ft-Wt-700">300 GMS</td>
          </tr>
          <tr>
            <td>EXTRA TAWA CHAPATI ( 3PC)</td>
            <td className="ft-Wt-700">40.00</td>
            <td className="ft-Wt-700">60 GMS</td>
          </tr>

          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="spacer">
            <td className="ft-Wt-700">SNACKS & CHAAT</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>SAMOSA (2PC)</td>
            <td className="ft-Wt-700">120.00</td>
            <td className="ft-Wt-700">70 GMS</td>
          </tr>
          <tr>
            <td>SAMOSA -CHHOLE CHAAT</td>
            <td className="ft-Wt-700">130.00</td>
            <td className="ft-Wt-700">100 GMS</td>
          </tr>

          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="spacer">
            <td className="ft-Wt-700">THALIS</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>PANEER BUTTER MASALA +DAL FRY +STEAM RICE+ VEG RAITA +3 TAWA CHAPATIS+SALAD+ GULAB JAMUN</td>
            <td className="ft-Wt-700">350.00</td>
            <td className="ft-Wt-700">650 GMS</td>
          </tr>

          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="spacer">
            <td className="ft-Wt-700">BIRYANIS</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>VEG BIRYANI WITH RAITA +SALAD</td>
            <td className="ft-Wt-700">280.00</td>
            <td className="ft-Wt-700">300 GMS</td>
          </tr>

          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="spacer">
            <td className="ft-Wt-700">ROLLS</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>PANEER BUTTER MASALA ROLL</td>
            <td className="ft-Wt-700">290.00</td>
            <td className="ft-Wt-700">200 GMS</td>
          </tr>
          <tr>
            <td>PANEER TIKKA ROLL</td>
            <td className="ft-Wt-700">290.00</td>
            <td className="ft-Wt-700">200 GMS</td>
          </tr>

          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="spacer">
            <td className="ft-Wt-700">BEVERAGES AND SWEET</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>1 PLATES GULAB JAMUN ( 2 PC )</td>
            <td className="ft-Wt-700">60.00</td>
            <td className="ft-Wt-700">50 GMS</td>
          </tr>
          <tr>
            <td>MASALA CHAAS ( 300 ML )</td>
            <td className="ft-Wt-700">80.00</td>
            <td className="ft-Wt-700">300 ML</td>
          </tr>
          <tr>
            <td>AAM PANNA</td>
            <td className="ft-Wt-700">70.00</td>
            <td className="ft-Wt-700">300 ML</td>
          </tr>
        </table>

        <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
         
          <tr className="title">
            <td colSpan={3}>CAFÉ BREWZ - CCD</td>
          </tr>
          <tr className="head">
            <td>BEVERAGES</td>
            <td>NEW PRICE</td>
            <td>GM/ML</td>
          </tr>

          <tr>
            <td>CAPPUCINNO</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">250 ml</td>
          </tr>
          <tr>
            <td>CAFÉ LATTE</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">250 ml</td>
          </tr>
          <tr>
            <td>CAFÉ MOCHA</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">250 ml</td>
          </tr>
          <tr>
            <td>AMERICANO</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">250 ml</td>
          </tr>
          <tr>
            <td>HOT CHOCOLATE</td>
            <td className="ft-Wt-700">180.00</td>
            <td className="ft-Wt-700">250 ml</td>
          </tr>
          <tr>
            <td>MASALA TEA</td>
            <td className="ft-Wt-700">60.00</td>
            <td className="ft-Wt-700">110 ml</td>
          </tr>
          <tr>
            <td>GREEN TEA</td>
            <td className="ft-Wt-700">70.00</td>
            <td className="ft-Wt-700">150 ml</td>
          </tr>
          <tr>
            <td>COLD COFFEE</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">300 ML</td>
          </tr>
          <tr>
            <td>ICE CHOCOLATE</td>
            <td className="ft-Wt-700">170.00</td>
            <td className="ft-Wt-700">300 ML</td>
          </tr>
          <tr>
            <td>ICE MOCHA</td>
            <td className="ft-Wt-700">250.00</td>
            <td className="ft-Wt-700">300 ML</td>
          </tr>
          <tr>
            <td>ICE AMERICANO</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">300 ML</td>
          </tr>

          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="spacer">
            <td className="ft-Wt-700">SNACKS</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>VEG MAXICAN PANINI S/W</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">190 gms</td>
          </tr>
          <tr>
            <td>MUMBAI MASALA CHEESE GRILLED S/W</td>
            <td className="ft-Wt-700">270.00</td>
            <td className="ft-Wt-700">230 gms</td>
          </tr>
          <tr>
            <td>VEG GRILL S/W (JAIN)</td>
            <td className="ft-Wt-700">220.00</td>
            <td className="ft-Wt-700">180 gms</td>
          </tr>
          <tr>
            <td>MELTED PANEER PANINI</td>
            <td className="ft-Wt-700">260.00</td>
            <td className="ft-Wt-700">200 GMS</td>
          </tr>
          <tr>
            <td>CHEESE MELTED TANDOORI PANEER TIKKA PANINI S/W</td>
            <td className="ft-Wt-700">NA</td>
            <td className="ft-Wt-700">170 GMS</td>
          </tr>
          <tr>
            <td>CLASSIC MARGRITA PIZZA</td>
            <td className="ft-Wt-700">250.00</td>
            <td className="ft-Wt-700">7'inch</td>
          </tr>
          <tr>
            <td>PEPPY PANEER CHEESE BURST PIZZA</td>
            <td className="ft-Wt-700">350.00</td>
            <td className="ft-Wt-700">7'inch</td>
          </tr>
          <tr>
            <td>CHEESE CORN PIZZA</td>
            <td className="ft-Wt-700">300.00</td>
            <td className="ft-Wt-700">7'inch</td>
          </tr>
          <tr>
            <td>DOUBLE CHEESE TOMATO SANDWICH</td>
            <td className="ft-Wt-700">250.00</td>
            <td className="ft-Wt-700">200 GMS</td>
          </tr>
        </table>
      </>
    );
  },

  db3: () => {
    return (
      <table>
        <tr className="title">
          <td colSpan={3}>ANANDO</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>SPECIAL MASALA MILK</td>
          <td className="ft-Wt-700"> 130.00 </td>
        </tr>
        <tr>
          <td>BELGIAN CHOCOLATE</td>
          <td className="ft-Wt-700"> 135.00 </td>
        </tr>
        <tr>
          <td>TROPICAL COCONUT</td>
          <td className="ft-Wt-700"> 130.00 </td>
        </tr>
        <tr>
          <td>SPLENDID STRAWBERRY</td>
          <td className="ft-Wt-700"> 130.00 </td>
        </tr>
        <tr>
          <td>TANGO WITH MANGO</td>
          <td className="ft-Wt-700"> 130.00 </td>
        </tr>
        <tr>
          <td>SINFUL SITAFAL</td>
          <td className="ft-Wt-700"> 130.00 </td>
        </tr>
        <tr>
          <td>CHOCO ALMOND CRUNCHY</td>
          <td className="ft-Wt-700"> 130.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>MAHARAJA BHOG ( 5 Dish Menu)</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>EXECUTIVE BOX</td>
          <td className="ft-Wt-700"> 300.00 </td>
        </tr>
        <tr>
          <td>PURI-5 PCS WITH BHAJI, ACHAR,SHRIKHAND</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>DAL BATTI CHURMA</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>VADA PAV</td>
          <td className="ft-Wt-700"> 40.00 </td>
        </tr>
        <tr>
          <td>SAMOSA PAV </td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>MASALA CHASS</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>RING DHOKLA WITH COCONUT CHUTNEY</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>TEA</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>VEG BIRYANI WITH RAITA, PAPAD &amp; GULAB JAMUN</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>THEPLA , BHAJI &amp; GULAB JAMUN</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>PAV BHAJI</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>EXPRESS BOX</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>CHETTINAD EXPRESS</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>IDLI (J)</td>
          <td className="ft-Wt-700"> 80.00 </td>
        </tr>
        <tr className="subHead">
          <td colSpan={3}>DOSA</td>
        </tr>
        <tr>
          <td>DOSA : SADA (J)</td>
          <td className="ft-Wt-700"> 90.00 </td>
        </tr>
        <tr>
          <td>DOSA : MASALA </td>
          <td className="ft-Wt-700"> 120.00 </td>
        </tr>
        <tr>
          <td>DOSA : MYSORE MASALA</td>
          <td className="ft-Wt-700"> 150.00 </td>
        </tr>
        <tr>
          <td>DOSA : MYSORE SADA </td>
          <td className="ft-Wt-700"> 130.00 </td>
        </tr>
        <tr>
          <td>DOSA : BUTTER CHEESE MASALA</td>
          <td className="ft-Wt-700"> 160.00 </td>
        </tr>
        <tr>
          <td>DOSA : BUTTER CHEESE (J)</td>
          <td className="ft-Wt-700"> 140.00 </td>
        </tr>
        <tr>
          <td>DOSA : PAV BHAJI (J)</td>
          <td className="ft-Wt-700"> 130.00 </td>
        </tr>
        <tr>
          <td>UTTAPPAM : ONION / TOMATO</td>
          <td className="ft-Wt-700"> 120.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>QUENCH</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr className="subHead">
          <td colSpan={3}>COOL</td>
        </tr>
        <tr>
          <td>WATER (1 LIT) </td>
          <td className="ft-Wt-700"> 20.00 </td>
        </tr>
        <tr>
          <td>WATER (200 ML) - 1 CASE </td>
          <td className="ft-Wt-700"> 288.00 </td>
        </tr>
        <tr>
          <td>SOFT BEVERAGES</td>
          <td> MRP </td>
        </tr>
        <tr>
          <td>MINUTE MAID</td>
          <td> MRP </td>
        </tr>
        <tr>
          <td>NATURE DAY</td>
          <td> MRP </td>
        </tr>
        <tr className="subHead">
          <td colSpan={3}>WARM</td>
        </tr>
        <tr>
          <td>TEA</td>
          <td className="ft-Wt-700"> 50.00 </td>
        </tr>
        <tr>
          <td>COFFEE</td>
          <td className="ft-Wt-700"> 50.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>R.S.MANI </td>
        </tr>
        <tr className="head">
          <td>NAME</td>
          <td> PRICE </td>
        </tr>
        <tr>
          <td> R S MANI FILTER COFFEE </td>
          <td className="ft-Wt-700"> 50.00 </td>
        </tr>
        <tr>
          <td> ADRAK CHAI </td>
          <td className="ft-Wt-700"> 50.00 </td>
        </tr>
        <tr>
          <td> IDLI </td>
          <td className="ft-Wt-700"> 80.00 </td>
        </tr>
        <tr>
          <td> MEDU VADA </td>
          <td className="ft-Wt-700"> 100.00 </td>
        </tr>
        <tr>
          <td> PINEAPPLE SHEERA </td>
          <td className="ft-Wt-700"> 120.00 </td>
        </tr>
        <tr>
          <td> DOSAS </td>
          <td className="ft-Wt-700"> 140.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>QUICK BITES</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td> PRICE </td>
        </tr>
        <tr>
          <td>AMRITSARI CHOLE KULCHE</td>
          <td className="ft-Wt-700"> 220.00 </td>
          <td className="ft-Wt-700"> 180-200 GMS </td>
        </tr>
        <tr>
          <td>SAMOSA CHOLE</td>
          <td className="ft-Wt-700"> 160.00 </td>
          <td className="ft-Wt-700"> 150-180 GMS </td>
        </tr>
        <tr>
          <td>MISAL PAV</td>
          <td className="ft-Wt-700"> 160.00 </td>
          <td className="ft-Wt-700"> 120 - 150 GMS </td>
        </tr>
        <tr>
          <td>VADA PAV (2 PCS)</td>
          <td className="ft-Wt-700"> 110.00 </td>
          <td className="ft-Wt-700"> 150 GMS </td>
        </tr>
        <tr>
          <td>SAMOSA PAV (2 PCS)</td>
          <td className="ft-Wt-700"> 120.00 </td>
          <td className="ft-Wt-700"> 150 GMS </td>
        </tr>
        <tr>
          <td>EXTRA PAV - (1PC)</td>
          <td className="ft-Wt-700"> 20.00 </td>
          <td className="ft-Wt-700"> 01 NOS </td>
        </tr>
        <tr>
          <td>EXTRA KULCHA / BHATURA - (1PC)</td>
          <td className="ft-Wt-700"> 20.00 </td>
          <td className="ft-Wt-700"> 01 NOS </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>INDIC</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td> PRICE </td>
        </tr>
        <tr>
          <td>URBAN THALI. (J)</td>
          <td className="ft-Wt-700"> 270.00 </td>
        </tr>
        <tr>
          <td>BIRYANI : PANEER MAKHANI (J)</td>
          <td className="ft-Wt-700"> 260.00 </td>
        </tr>
        <tr>
          <td>BIRYANI : SUBZ (J)</td>
          <td className="ft-Wt-700"> 250.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>DAILY DELI</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr className="subHead">
          <td colSpan={3}>SANDWICH</td>
        </tr>
        <tr>
          <td>GRILLED VEG SANDWICH (J)</td>
          <td className="ft-Wt-700"> 160.00 </td>
        </tr>
        <tr>
          <td>GRILLED VEG SANDWICH WITH CHEESE (J)</td>
          <td className="ft-Wt-700"> 180.00 </td>
        </tr>
        <tr className="subHead">
          <td colSpan={3}>WRAPS</td>
        </tr>
        <tr>
          <td>VEGETABLE WRAPS (J)</td>
          <td className="ft-Wt-700"> 120.00 </td>
        </tr>
        <tr>
          <td>CHEESE &amp; VEGETABLE WRAPS (J)</td>
          <td className="ft-Wt-700"> 140.00 </td>
        </tr>
        <tr>
          <td>FRENCH FRIES</td>
          <td className="ft-Wt-700"> 90.00 </td>
        </tr>
        <tr className="subHead">
          <td colSpan={3}>PIZZA </td>
        </tr>
        <tr>
          <td>CHEESE MARGHERITA</td>
          <td className="ft-Wt-700"> 260.00 </td>
        </tr>
        <tr>
          <td>VEGGIE DELIGHT </td>
          <td className="ft-Wt-700"> 270.00 </td>
        </tr>
        <tr>
          <td>PEPPY PANEER </td>
          <td className="ft-Wt-700"> 280.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>CHINA TIMES</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td> PRICE </td>
        </tr>
        <tr className="subHead">
          <td colSpan={3}> CHINESE COMBOS </td>
        </tr>
        <tr>
          <td> FRIED RICE WITH MANCHURIAN (J) </td>
          <td className="ft-Wt-700"> 260.00 </td>
        </tr>
        <tr>
          <td> NOODLES WITH MANCHURIAN (J) </td>
          <td className="ft-Wt-700"> 260.00 </td>
        </tr>
        <tr>
          <td> VEG FRIED RICE </td>
          <td className="ft-Wt-700"> 180.00 </td>
        </tr>
        <tr>
          <td> VEG NOODLES </td>
          <td className="ft-Wt-700"> 180.00</td>
        </tr>
      </table>
    );
  },
  openBay: () => {
    return (
      <table>
        <tr className="title">
          <td colSpan={3}>SHIV SAGAR</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
          <td></td>
        </tr>
        <tr>
          <td>PAV BHAJI</td>
          <td className="ft-Wt-700"> 200.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="title">
          <td colSpan={3}>INDIC THALI</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
          <td></td>
        </tr>
        <tr>
          <td>URBAN THALI- VEG</td>
          <td className="ft-Wt-700"> 270.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="title">
          <td colSpan={3}>R.S.MANI </td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
          <td></td>
        </tr>
        <tr>
          <td> DOSA SADA </td>
          <td className="ft-Wt-700"> 100.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td> DOSA MASALA </td>
          <td className="ft-Wt-700"> 120.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td> BUTTER SADA DOSA </td>
          <td className="ft-Wt-700"> 120.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td> GHEE ROAST </td>
          <td className="ft-Wt-700"> 140.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td> MYSORE SADA DOSA </td>
          <td className="ft-Wt-700"> 120.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td> MYSORE MASALA DOSA </td>
          <td className="ft-Wt-700"> 140.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td> IDLI WADA PLATE</td>
          <td className="ft-Wt-700"> 100.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="title">
          <td colSpan={3}>CHINA TIME</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
          <td></td>
        </tr>
        <tr>
          <td>MEAL - VEG FRIED RICE</td>
          <td className="ft-Wt-700"> 180.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>Paneer Veg Chilly in Basil Sauce</td>
          <td className="ft-Wt-700"> 180.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>Veg Combo</td>
          <td className="ft-Wt-700"> 260.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="title">
          <td colSpan={3}>QUICK BITES</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
          <td></td>
        </tr>
        <tr>
          <td>CHOLE KULCHA</td>
          <td className="ft-Wt-700"> 150.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="title">
          <td colSpan={3}>TIBBS</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
          <td></td>
        </tr>
        <tr>
          <td>VEG FRANKIE</td>
          <td className="ft-Wt-700"> 160.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>TAWA PANEER</td>
          <td className="ft-Wt-700"> 160.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="title">
          <td colSpan={3}>MAHARAJA BHOG</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
          <td></td>
        </tr>
        <tr>
          <td>VADA PAV </td>
          <td className="ft-Wt-700"> 40.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>SAMOSA PAV </td>
          <td className="ft-Wt-700"> 60.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="title">
          <td colSpan={3}>RAJDHANI THALI</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
          <td></td>
        </tr>
        <tr>
          <td>RAJDHANI EXECUTIVE THALI</td>
          <td className="ft-Wt-700"> 280.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>Samosa - 2 Pcs</td>
          <td className="ft-Wt-700"> 60 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>(Samosa 2 Pcs + Chutney + Fried Chilli)</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Khaman Dhokla </td>
          <td className="ft-Wt-700"> 100 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>(Dhokla 5 Pcs + Chutney + Fried Chilli)</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Samosa Chole Chat</td>
          <td className="ft-Wt-700"> 110 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>(Samosa 2 Pc + Chole + Chutney)</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Khasta Kachori Chat</td>
          <td className="ft-Wt-700"> 100 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>(Kachori 1 Pc + Dahi + Chutney)</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Misal Pav </td>
          <td className="ft-Wt-700"> 120 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>(Misal + Pav 2 Pcs + Onion + Lemon)</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Rajdhani Executive Thali</td>
          <td className="ft-Wt-700"> 280 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>
            (Farsan + 2 Veg + 3 Chapati + Dal + Rice + 1 Sweet + Accompaniments)
          </td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Paneer Combo Meal</td>
          <td className="ft-Wt-700"> 250 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>
            (Paneer Veg + 3 Chapati + Dal + Rice + 1 Sweet + Accompaniments)
          </td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Chole Puri </td>
          <td className="ft-Wt-700"> 180 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>(Chole + Puri 5 Pcs + Accompaniments)</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Puri Bhaji  </td>
          <td className="ft-Wt-700"> 150 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>(Aloo Sabzi + Puri 5 Pcs +  Accompaniments)</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Masala Chaas</td>
          <td className="ft-Wt-700"> 60 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>Maharaja Lassi</td>
          <td className="ft-Wt-700"> 100 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>Extra Pav - 1 Pc</td>
          <td className="ft-Wt-700"> 10 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>Gulab Jamun - 2 Pcs</td>
          <td className="ft-Wt-700"> 50 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr className="title">
          <td colSpan={3}>Society Tea Terminal</td>
        </tr>
        <tr className="head">
          <td>Menu</td>
          <td> MRP </td>
          <td></td>
        </tr>
        <tr>
          <td>REGULAR TEA </td>
          <td className="ft-Wt-700"> 50.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>MASALA TEA </td>
          <td className="ft-Wt-700"> 50.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>ELAICHI TEA </td>
          <td className="ft-Wt-700"> 50.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>ICED TEA</td>
          <td className="ft-Wt-700"> 80.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>CAPPUCCINO</td>
          <td className="ft-Wt-700"> 60.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>COLD COFFEE</td>
          <td className="ft-Wt-700"> 100.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>KHARI </td>
          <td className="ft-Wt-700"> 40.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>TOAST </td>
          <td className="ft-Wt-700"> 40.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>BUN MASKA JAM (1 PC)</td>
          <td className="ft-Wt-700"> 60.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>GREEN TEA BAGS</td>
          <td className="ft-Wt-700"> 60.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>CLEANSE</td>
          <td className="ft-Wt-700"> 60.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>HALDI DOODH</td>
          <td className="ft-Wt-700"> 60.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>POHA</td>
          <td className="ft-Wt-700"> 70.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>UPMA</td>
          <td className="ft-Wt-700"> 70.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>SANDWICH VEG</td>
          <td className="ft-Wt-700"> 100.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>VEG PUFF</td>
          <td className="ft-Wt-700"> 40.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>CHEESE PUFF</td>
          <td className="ft-Wt-700"> 50.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>SAMOSA ( 1 PC)</td>
          <td className="ft-Wt-700"> 40.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>VADA </td>
          <td className="ft-Wt-700"> 40.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td>PAV</td>
          <td className="ft-Wt-700"> 10.00 </td>
          <td className="ft-Wt-700"></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr className="title">
          <td colSpan={3}>BEVERAGE COUNTER</td>
        </tr>
        <tr className="head">
          <td>Menu</td>
          <td> MRP ( PER BTL) </td>
          <td> MRP (CASE) </td>
        </tr>
        <tr>
          <td>BISLERI MINERAL WATER 1 LTR (12 NOS)</td>
          <td className="ft-Wt-700"> 20.00 </td>
          <td className="ft-Wt-700"> 240.00 </td>
        </tr>
        <tr>
          <td>BISLERI MINERAL WATER 250 ML (48 NOS)</td>
          <td className="ft-Wt-700"> 10.00 </td>
          <td className="ft-Wt-700"> 290.00 </td>
        </tr>
        <tr>
          <td>BISLERI LIMONATA 160 ML (24 NOS)</td>
          <td className="ft-Wt-700"> 10.00 </td>
          <td className="ft-Wt-700"> 240.00 </td>
        </tr>
        <tr>
          <td>BISLERI POP - ORANGE 160 ML (24 NOS)</td>
          <td className="ft-Wt-700"> 10.00 </td>
          <td className="ft-Wt-700"> 240.00 </td>
        </tr>
        <tr>
          <td>COKE OR THUMPS UP 250 ML (24 NOS)</td>
          <td className="ft-Wt-700"> 20.00 </td>
          <td className="ft-Wt-700"> 480.00 </td>
        </tr>
        <tr>
          <td>LIMCA OR SLICE 250 ML ( 24 NOS)</td>
          <td className="ft-Wt-700"> 20.00 </td>
          <td className="ft-Wt-700"> 480.00</td>
        </tr>
        <tr className="title">
          <td colSpan={3}>LOKAL</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>LOKAL VEG THALI</td>
          <td className="ft-Wt-700"> 280.00 </td>
        </tr>
        <tr>
          <td>LOKAL THEPLA</td>
          <td className="ft-Wt-700"> 70.00 </td>
        </tr>
        <tr>
          <td>JALEBI &amp; FAFDA</td>
          <td className="ft-Wt-700"> 135.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>SHIV SAGAR</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>INDIAN EXPRESS COMBO</td>
          <td className="ft-Wt-700"> 300.00 </td>
        </tr>
        <tr>
          <td>PAV BHAJI (J)</td>
          <td className="ft-Wt-700"> 150.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>CHETTINAD EXPRESS</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>DOSA : SADA </td>
          <td className="ft-Wt-700"> 90.00 </td>
        </tr>
        <tr>
          <td>DOSA : MASALA </td>
          <td className="ft-Wt-700"> 120.00 </td>
        </tr>
        <tr>
          <td>DOSA : MYSORE MASALA</td>
          <td className="ft-Wt-700"> 140.00 </td>
        </tr>
        <tr>
          <td>DOSA : MYSORE SADA </td>
          <td className="ft-Wt-700"> 120.00 </td>
        </tr>
        <tr>
          <td>IDLI WADA PLATE</td>
          <td className="ft-Wt-700"> 80.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>WOW MOMOS</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>VEG DARJEELING STEAM MOMO (Steamed)</td>
          <td className="ft-Wt-700"> 160.00 </td>
        </tr>
        <tr>
          <td>PANEER STEAM MOMO (Steamed)</td>
          <td className="ft-Wt-700"> 190.00 </td>
        </tr>
        <tr>
          <td>CORN CHEESE STEAM MOMO (Steamed)</td>
          <td className="ft-Wt-700"> 210.00 </td>
        </tr>
        <tr>
          <td>VEG DARJEELING FRIED MOMO (Fried)</td>
          <td className="ft-Wt-700"> 160.00 </td>
        </tr>
        <tr>
          <td>PANEER FRIED MOMO (Fried)</td>
          <td className="ft-Wt-700"> 190.00 </td>
        </tr>
        <tr>
          <td>CORN CHEESE FRIED MOMO (Fried)</td>
          <td className="ft-Wt-700"> 210.00 </td>
        </tr>
        <tr>
          <td>VEG DARJEELING PAN FRIED MOMO</td>
          <td className="ft-Wt-700"> 210.00 </td>
        </tr>
        <tr>
          <td>PANEER PAN FRIED MOMO</td>
          <td className="ft-Wt-700"> 220.00 </td>
        </tr>
        <tr>
          <td>CORN CHEESE PAN FRIED MOMO</td>
          <td className="ft-Wt-700"> 260.00 </td>
        </tr>
        <tr>
          <td>CHIILLY PANEER DRY</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>FRIED RICE WITH CHILLI PANEER</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>FRIED RICE WITH VEG MANCHURIAN</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>HAKKA NOODLES WITH CHILLI PANEER</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>HAKKA NOODLES WITH VEG MANCHURIAN</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>COCO CHARGE</td>
          <td className="ft-Wt-700"> 100.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>QUICK BITES</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>CHOLE KULCHA (J)</td>
          <td className="ft-Wt-700"> 150.00 </td>
        </tr>
        <tr>
          <td>SAMOSA (J)</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>VADA PAV (J)</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>CHOLE KULCHA</td>
          <td className="ft-Wt-700"> 150.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>Society Tea Terminal</td>
        </tr>
        <tr className="head">
          <td>Menu</td>
          <td> MRP </td>
        </tr>
        <tr>
          <td>REGULAR TEA </td>
          <td className="ft-Wt-700"> 50.00 </td>
        </tr>
        <tr>
          <td>MASALA TEA </td>
          <td className="ft-Wt-700"> 50.00 </td>
        </tr>
        <tr>
          <td>ELAICHI TEA </td>
          <td className="ft-Wt-700"> 50.00 </td>
        </tr>
        <tr>
          <td>ICED TEA</td>
          <td className="ft-Wt-700"> 80.00 </td>
        </tr>
        <tr>
          <td>CAPPUCCINO</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>COLD COFFEE</td>
          <td className="ft-Wt-700"> 100.00 </td>
        </tr>
        <tr>
          <td>KHARI 2PC</td>
          <td className="ft-Wt-700"> 40.00 </td>
        </tr>
        <tr>
          <td>TOAST 2PC</td>
          <td className="ft-Wt-700"> 40.00 </td>
        </tr>
        <tr>
          <td>BUN MASKA JAM (1 PC)</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>GREEN TEA BAGS</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>CLEANSE</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>HALDI DOODH</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>POHA</td>
          <td className="ft-Wt-700"> 70.00 </td>
        </tr>
        <tr>
          <td>UPMA</td>
          <td className="ft-Wt-700"> 70.00 </td>
        </tr>
        <tr>
          <td>SANDWICH VEG</td>
          <td className="ft-Wt-700"> 100.00 </td>
        </tr>
        <tr>
          <td>VEG PUFF</td>
          <td className="ft-Wt-700"> 40.00 </td>
        </tr>
        <tr>
          <td>CHEESE PUFF</td>
          <td className="ft-Wt-700"> 50.00 </td>
        </tr>
        <tr>
          <td>SAMOSA ( 1 PC)</td>
          <td className="ft-Wt-700"> 40.00 </td>
        </tr>
        <tr>
          <td>VADA </td>
          <td className="ft-Wt-700"> 40.00 </td>
        </tr>
        <tr>
          <td>PAV</td>
          <td className="ft-Wt-700"> 10.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>BEVERAGE COUNTER</td>
        </tr>
        <tr className="head">
          <td>Menu</td>
          <td> MRP ( PER BTL) </td>
        </tr>
        <tr>
          <td>BISLERI MINERAL WATER 1 LTR (12 NOS)</td>
          <td className="ft-Wt-700"> 20.00 </td>
        </tr>
        <tr>
          <td>BISLERI MINERAL WATER 250 ML (48 NOS)</td>
          <td className="ft-Wt-700"> 10.00 </td>
        </tr>
        <tr>
          <td>BISLERI LIMONATA 160 ML (24 NOS)</td>
          <td className="ft-Wt-700"> 10.00 </td>
        </tr>
        <tr>
          <td>BISLERI POP - ORANGE 160 ML (24 NOS)</td>
          <td className="ft-Wt-700"> 10.00 </td>
        </tr>
        <tr>
          <td>COKE OR THUMPS UP 250 ML (24 NOS)</td>
          <td className="ft-Wt-700"> 20.00 </td>
        </tr>
        <tr>
          <td>LIMCA OR SLICE 250 ML ( 24 NOS)</td>
          <td className="ft-Wt-700"> 20.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>TIBBS</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>VEG FRANKIE</td>
          <td className="ft-Wt-700"> 160.00 </td>
        </tr>
        <tr>
          <td>TAWA PANEER</td>
          <td className="ft-Wt-700"> 160.00</td>
        </tr>
      </table>
    );
  },
  foodCourt: () => {
    return (
      <table>
        <tr className="title">
          <td colSpan={3}>LOKAL</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>LOKAL VEG THALI</td>
          <td className="ft-Wt-700"> 280.00 </td>
        </tr>
        <tr>
          <td>LOKAL THEPLA</td>
          <td className="ft-Wt-700"> 70.00 </td>
        </tr>
        <tr>
          <td>JALEBI &amp; FAFDA</td>
          <td className="ft-Wt-700"> 135.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>SHIV SAGAR</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>PAVBHAJI </td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>SADA DOSA</td>
          <td className="ft-Wt-700"> 100.00 </td>
        </tr>
        <tr>
          <td>MASALA DOSA</td>
          <td className="ft-Wt-700"> 120.00 </td>
        </tr>
        <tr>
          <td>MYSORE SADA</td>
          <td className="ft-Wt-700"> 130.00 </td>
        </tr>
        <tr>
          <td>MYSORE MASALA </td>
          <td className="ft-Wt-700"> 150.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}> CHHOLAY</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>CHOLE KULCHA</td>
          <td className="ft-Wt-700"> 190.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>QUENCH</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>TEA </td>
          <td className="ft-Wt-700"> 50.00 </td>
        </tr>
        <tr>
          <td>COFFEE</td>
          <td className="ft-Wt-700"> 50.00 </td>
        </tr>
        <tr>
          <td>VADA PAV </td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>SAMOSA </td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>WOW MOMOS</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>VEG DARJEELING STEAM MOMO (Steamed) 5pcs.</td>
          <td className="ft-Wt-700"> 160.00 </td>
        </tr>
        <tr>
          <td>PANEER STEAM MOMO (Steamed) 5pcs.</td>
          <td className="ft-Wt-700"> 190.00 </td>
        </tr>
        <tr>
          <td>CORN CHEESE STEAM MOMO (Steamed) 5pcs.</td>
          <td className="ft-Wt-700"> 210.00 </td>
        </tr>
        <tr>
          <td>VEG DARJEELING FRIED MOMO (Fried) 5pcs.</td>
          <td className="ft-Wt-700"> 160.00 </td>
        </tr>
        <tr>
          <td>PANEER FRIED MOMO (Fried) 5pcs.</td>
          <td className="ft-Wt-700"> 190.00 </td>
        </tr>
        <tr>
          <td>CORN CHEESE FRIED MOMO (Fried) 5pcs.</td>
          <td className="ft-Wt-700"> 210.00 </td>
        </tr>
        <tr>
          <td>VEG DARJEELING PAN FRIED MOMO 5pcs.</td>
          <td className="ft-Wt-700"> 210.00 </td>
        </tr>
        <tr>
          <td>PANEER PAN FRIED MOMO 5pcs</td>
          <td className="ft-Wt-700"> 220.00 </td>
        </tr>
        <tr>
          <td>CORN CHEESE PAN FRIED MOMO 5pcs.</td>
          <td className="ft-Wt-700"> 260.00 </td>
        </tr>
        <tr>
          <td>CHIILLY PANEER DRY</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>FRIED RICE WITH CHILLI PANEER</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>FRIED RICE WITH VEG MANCHURIAN</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>HAKKA NOODLES WITH CHILLI PANEER</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>HAKKA NOODLES WITH VEG MANCHURIAN</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr className="head">
          <td>COCO CHARGE</td>
          <td className="ft-Wt-700"> 100.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>BEVERAGE COUNTER</td>
        </tr>
        <tr className="head">
          <td>Menu</td>
          <td> MRP ( PER BTL) </td>
        </tr>
        <tr>
          <td>BISLERI MINERAL WATER 1 LTR (12 NOS)</td>
          <td className="ft-Wt-700"> 20.00 </td>
        </tr>
        <tr>
          <td>BISLERI MINERAL WATER 250 ML (48 NOS)</td>
          <td className="ft-Wt-700"> 10.00 </td>
        </tr>
        <tr>
          <td>BISLERI LIMONATA 160 ML (24 NOS)</td>
          <td className="ft-Wt-700"> 10.00 </td>
        </tr>
        <tr>
          <td>BISLERI POP - ORANGE 160 ML (24 NOS)</td>
          <td className="ft-Wt-700"> 10.00 </td>
        </tr>
        <tr>
          <td>COKE OR THUMPS UP 250 ML (24 NOS)</td>
          <td className="ft-Wt-700"> 20.00 </td>
        </tr>
        <tr>
          <td>LIMCA OR SLICE 250 ML ( 24 NOS)</td>
          <td className="ft-Wt-700"> 20.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>Society Tea Terminal</td>
        </tr>
        <tr className="head">
          <td>Menu</td>
          <td> MRP </td>
        </tr>
        <tr>
          <td>REGULAR TEA </td>
          <td className="ft-Wt-700"> 50.00 </td>
        </tr>
        <tr>
          <td>MASALA TEA </td>
          <td className="ft-Wt-700"> 50.00 </td>
        </tr>
        <tr>
          <td>ELAICHI TEA </td>
          <td className="ft-Wt-700"> 50.00 </td>
        </tr>
        <tr>
          <td>ICED TEA</td>
          <td className="ft-Wt-700"> 80.00 </td>
        </tr>
        <tr>
          <td>CAPPUCCINO</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>COLD COFFEE</td>
          <td className="ft-Wt-700"> 100.00 </td>
        </tr>
        <tr>
          <td>KHARI 2PC</td>
          <td className="ft-Wt-700"> 40.00 </td>
        </tr>
        <tr>
          <td>TOAST 2PC</td>
          <td className="ft-Wt-700"> 40.00 </td>
        </tr>
        <tr>
          <td>BUN MASKA JAM (1 PC)</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>GREEN TEA BAGS</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>CLEANSE</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>HALDI DOODH</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>POHA</td>
          <td className="ft-Wt-700"> 70.00 </td>
        </tr>
        <tr>
          <td>UPMA</td>
          <td className="ft-Wt-700"> 70.00 </td>
        </tr>
        <tr>
          <td>SANDWICH VEG</td>
          <td className="ft-Wt-700"> 100.00 </td>
        </tr>
        <tr>
          <td>VEG PUFF</td>
          <td className="ft-Wt-700"> 40.00 </td>
        </tr>
        <tr>
          <td>CHEESE PUFF</td>
          <td className="ft-Wt-700"> 50.00 </td>
        </tr>
        <tr>
          <td>SAMOSA ( 1 PC)</td>
          <td className="ft-Wt-700"> 40.00 </td>
        </tr>
        <tr>
          <td>VADA </td>
          <td className="ft-Wt-700"> 40.00 </td>
        </tr>
        <tr>
          <td>PAV</td>
          <td className="ft-Wt-700"> 10.00</td>
        </tr>
        <tr className="title">
          <td colSpan={3}>MAHARAJA BHOG</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>EXECUTIVE BOX</td>
          <td className="ft-Wt-700"> 300.00 </td>
        </tr>
        <tr>
          <td>RING DHOKLA WITH COCONUT CHUTNEY</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>TEA</td>
          <td className="ft-Wt-700"> 60.00 </td>
        </tr>
        <tr>
          <td>VEG BIRYANI WITH RAITA, PAPAD &amp; GULAB JAMUN</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>THEPLA , BHAJI &amp; GULAB JAMUN</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>PAV BHAJI</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>
        <tr>
          <td>EXPRESS BOX</td>
          <td className="ft-Wt-700"> 200.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>SHIV SAGAR</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>PAV BHAJI (J)</td>
          <td className="ft-Wt-700"> 150.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>R.S.MANI </td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td> DOSA SADA </td>
          <td className="ft-Wt-700"> 100.00 </td>
        </tr>
        <tr>
          <td> DOSA MASALA </td>
          <td className="ft-Wt-700"> 120.00 </td>
        </tr>
        <tr>
          <td> BUTTER SADA DOSA </td>
          <td className="ft-Wt-700"> 120.00 </td>
        </tr>
        <tr>
          <td> GHEE ROAST </td>
          <td className="ft-Wt-700"> 140.00 </td>
        </tr>
        <tr>
          <td> MYSORE SADA DOSA </td>
          <td className="ft-Wt-700"> 120.00 </td>
        </tr>
        <tr>
          <td> MYSORE MASALA DOSA </td>
          <td className="ft-Wt-700"> 140.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>CHINA TIME</td>
        </tr>
        <tr className="head">
          <td>MENU</td>
          <td>PRICE</td>
        </tr>
        <tr>
          <td>MEAL - VEG FRIED RICE</td>
          <td className="ft-Wt-700"> 180.00 </td>
        </tr>
        <tr>
          <td>Paneer Veg Chilly in Basil Sauce</td>
          <td className="ft-Wt-700"> 180.00 </td>
        </tr>
        <tr>
          <td>Veg Combo</td>
          <td className="ft-Wt-700"> 260.00 </td>
        </tr>

        <tr className="title">
          <td colSpan={3}>BEVERAGE COUNTER</td>
        </tr>
        <tr className="head">
          <td>Menu</td>
          <td> MRP ( PER BTL) </td>
        </tr>
        <tr>
          <td>BISLERI MINERAL WATER 1 LTR (12 NOS)</td>
          <td className="ft-Wt-700"> 20.00 </td>
        </tr>
        <tr>
          <td>BISLERI MINERAL WATER 250 ML (48 NOS)</td>
          <td className="ft-Wt-700"> 10.00 </td>
        </tr>
        <tr>
          <td>BISLERI LIMONATA 160 ML (24 NOS)</td>
          <td className="ft-Wt-700"> 10.00 </td>
        </tr>
        <tr>
          <td>BISLERI POP - ORANGE 160 ML (24 NOS)</td>
          <td className="ft-Wt-700"> 10.00 </td>
        </tr>
        <tr>
          <td>COKE OR THUMPS UP 250 ML (24 NOS)</td>
          <td className="ft-Wt-700"> 20.00 </td>
        </tr>
        <tr>
          <td>LIMCA OR SLICE 250 ML ( 24 NOS)</td>
          <td className="ft-Wt-700"> 20.00</td>
        </tr>
      </table>
    );
  },
  jioCafe1: () => {
    return (
      <table>
        <tr className="title"><td colSpan={5}>CAFETERIA MENU – IIJS BHARAT PREMIERE 2026</td></tr>
        <tr className="subHead"><td colSpan={5}>Venue: Jasmine Hall Niche &amp; Lotus Ballroom Niche</td></tr>

        {/* ================= FOOD COURT KIOSK - LOW TEA ================= */}
        <tr className="title"><td colSpan={5}>FOOD COURT KIOSK – LOW TEA</td></tr>
        <tr className="subHead"><td colSpan={5}>4+3 = 7 Stations (3 at Pavilion + 4 at Level 3) | TIME: 09:00 AM – 07:00 PM</td></tr>
        <tr className="head"><td>Item</td><td>Price (₹)</td><td>Jain</td><td colSpan={2}>Allergens</td></tr>

        <tr className="subHead"><td colSpan={5}>COOKIES</td></tr>
        <tr><td>Any 2 Pieces</td><td>70</td><td>Yes</td><td colSpan={2}>Wheat, Nut, Milk, Soy</td></tr>
        <tr><td>Single Piece</td><td>40</td><td>Yes</td><td colSpan={2}>Wheat, Nut, Milk, Soy</td></tr>
        <tr><td>Oatmeal Coco Chip Cookies (Jain)</td><td>—</td><td>Yes</td><td colSpan={2}>Wheat, Nut, Milk, Soy</td></tr>
        <tr><td>Nankhatai (Jain)</td><td>—</td><td>Yes</td><td colSpan={2}>Wheat, Milk</td></tr>

        <tr className="subHead"><td colSpan={5}>SNACKS</td></tr>
        <tr><td>Vada Pav (2 pcs)</td><td>150</td><td>No</td><td colSpan={2}>Wheat, Milk</td></tr>
        <tr><td>Kaju Mutter Samosa (2 pcs) – Jain</td><td>150</td><td>Yes</td><td colSpan={2}>Wheat, Milk</td></tr>
        <tr><td>Vegetable Upma with Chutney (Jain) – 09:00–11:00 AM</td><td>150</td><td>Yes</td><td colSpan={2}>Wheat, Milk</td></tr>
        <tr><td>Khaman Dhokla with Chutney (4 pcs, Jain) – 09:00–11:00 AM</td><td>150</td><td>Yes</td><td colSpan={2}>Wheat</td></tr>

        <tr className="subHead"><td colSpan={5}>SALADS – GRAB N GO</td></tr>
        <tr><td>Fresh Fruits Bowl (Jain)</td><td>250</td><td>Yes</td><td colSpan={2}>—</td></tr>

        <tr className="subHead"><td colSpan={5}>HOT BEVERAGES</td></tr>
        <tr><td>Readymade Tea</td><td>125</td><td>—</td><td colSpan={2}>Milk</td></tr>
        <tr><td>Readymade Coffee</td><td>100</td><td>—</td><td colSpan={2}>Milk</td></tr>
        <tr><td>Espresso / Café Latte / Cappuccino</td><td>150</td><td>—</td><td colSpan={2}>Milk</td></tr>

        <tr className="subHead"><td colSpan={5}>SANDWICHES (GRAB &amp; GO)</td></tr>
        <tr><td>Avocado, Rucola &amp; Cream Cheese Sandwich (Jain)</td><td>250</td><td>Yes</td><td colSpan={2}>Wheat, Milk</td></tr>
        <tr><td>Chutney &amp; Cheese Sandwich (Jain)</td><td>150</td><td>Yes</td><td colSpan={2}>Wheat, Milk</td></tr>

        <tr className="subHead"><td colSpan={5}>PREPACKAGED TREATS &amp; BEVERAGES</td></tr>
        <tr><td>Klaw Super Grain Puffs – Pudina Blast</td><td>MRP</td><td>—</td><td colSpan={2}>See label</td></tr>
        <tr><td>Klaw Super Grain Puffs – Spicy Guava</td><td>MRP</td><td>—</td><td colSpan={2}>See label</td></tr>
        <tr><td>Anando's Masala Milk (180 ml)</td><td>MRP</td><td>—</td><td colSpan={2}>Milk</td></tr>
        <tr><td>Anando's Cold Coffee (180 ml)</td><td>MRP</td><td>—</td><td colSpan={2}>Milk</td></tr>
        <tr><td>Aerated Beverages – Campa (330 ml)</td><td>100</td><td>—</td><td colSpan={2}>—</td></tr>
        <tr><td>Red Bull (330 ml)</td><td>190</td><td>—</td><td colSpan={2}>—</td></tr>
        <tr><td>Raw Pressery (Mixed Fruit / Valencia Orange)</td><td>MRP</td><td>—</td><td colSpan={2}>—</td></tr>
        <tr><td>Aava Water (500 ml)</td><td>50</td><td>—</td><td colSpan={2}>—</td></tr>
        <tr><td>Aava Water Case (200 ml × 24)</td><td>350</td><td>—</td><td colSpan={2}>—</td></tr>

        {/* ================= INTERACTIVE STAGE – MUMBAI STREET FOOD ================= */}
        <tr className="title"><td colSpan={5}>MUMBAI STREET FOOD – 2 Counters</td></tr>
        <tr className="subHead"><td colSpan={5}>TIME: 11:00 AM – 07:00 PM</td></tr>
        <tr className="head"><td>Item</td><td>Price (₹)</td><td>Jain</td><td colSpan={2}>Allergens</td></tr>
        <tr><td>Misal Pav + 1 Aava 200 ml</td><td>200</td><td>No</td><td colSpan={2}>Wheat, Milk, Mustard, Sesame</td></tr>
        <tr><td>Pav Bhaji + 1 Aava 200 ml</td><td>200</td><td>No</td><td colSpan={2}>Wheat, Milk</td></tr>
        <tr><td>Martabaan ke Chole Kulche + 1 Aava 200 ml (Jain)</td><td>250</td><td>Yes</td><td colSpan={2}>Wheat, Milk</td></tr>

        {/* ================= SANDWICH & WRAPS ================= */}
        <tr className="title"><td colSpan={5}>SANDWICH &amp; WRAPS – 2 Counters</td></tr>
        <tr className="subHead"><td colSpan={5}>TIME: 11:00 AM – 07:00 PM</td></tr>
        <tr className="head"><td>Item</td><td>Price (₹)</td><td colSpan={3}>Allergens</td></tr>
        <tr><td>Mumbai Masala Toastie</td><td>250</td><td colSpan={3}>Wheat, Milk</td></tr>
        <tr><td>Paneer Kathi Roll</td><td>350</td><td colSpan={3}>Wheat, Milk</td></tr>
        <tr><td>Crisp Falafel Wrap (Hummus, Pickles)</td><td>300</td><td colSpan={3}>Wheat, Sesame</td></tr>

        {/* ================= TITHI FOOD (6th Aug only) ================= */}
        <tr className="title"><td colSpan={5}>TITHI FOOD – 2 Counters (6th August only)</td></tr>
        <tr className="subHead"><td colSpan={5}>TIME: 11:00 AM – 07:00 PM</td></tr>
        <tr className="head"><td>Item</td><td>Price (₹)</td><td colSpan={3}>Includes</td></tr>
        <tr><td>Tithi Thali</td><td>400</td><td colSpan={3}>Puran Poli, Dahi Bhalla, Khaman Dhokla, Rajma, Rice &amp; Water</td></tr>
        <tr><td>Chole Parathe</td><td>350</td><td colSpan={3}>Contains Gluten</td></tr>

        {/* ================= WHOLESOME MEALS ================= */}
        <tr className="title"><td colSpan={5}>WHOLESOME &amp; CHOICE MEALS – 2 Counters</td></tr>
        <tr className="subHead"><td colSpan={5}>TIME: 12:00 PM – 04:00 PM</td></tr>
        <tr className="head"><td>Meal</td><td>Price (₹)</td><td colSpan={3}>Allergens</td></tr>
        <tr><td>Indian Veg Meal + 1 Aava 200 ml</td><td>400</td><td colSpan={3}>Milk, Nut, Wheat</td></tr>
        <tr><td>Asian Veg Meal + 1 Aava 200 ml</td><td>400</td><td colSpan={3}>Milk, Nut, Soy, Wheat</td></tr>

        {/* ================= CHAAT STAGE ================= */}
        <tr className="title"><td colSpan={5}>CHAAT STAGE – 2 Counters</td></tr>
        <tr className="subHead"><td colSpan={5}>TIME: 12:00 PM – 07:00 PM | Jain options available</td></tr>
        <tr className="head"><td>Item</td><td>Price (₹)</td><td colSpan={3}>Allergens</td></tr>
        <tr><td>Sev Puri</td><td>120</td><td colSpan={3}>Wheat, Milk</td></tr>
        <tr><td>Pan Patta Chaat</td><td>120</td><td colSpan={3}>Wheat, Milk</td></tr>
        <tr><td>Papdi Chaat</td><td>120</td><td colSpan={3}>Wheat, Milk</td></tr>
        <tr><td>Mumbai Geeli Bhel Poori</td><td>120</td><td colSpan={3}>Wheat, Nut</td></tr>
        <tr><td>Ragda Pattice</td><td>120</td><td colSpan={3}>Wheat, Nut</td></tr>

        {/* ================= THE RAMESHWARAM CAFÉ ================= */}
        <tr className="title"><td colSpan={5}>THE RAMESHWARAM CAFÉ – 2 Counters</td></tr>
        <tr className="subHead"><td colSpan={5}>11:00 AM – 07:00 PM | Served with coconut chutney, tomato chutney &amp; drumstick sambhar</td></tr>
        <tr className="head"><td>Item</td><td>Price (₹)</td><td colSpan={3}>Allergens</td></tr>
        <tr><td>Ghee Podi Idli</td><td>250</td><td colSpan={3}>Dairy, Sesame</td></tr>
        <tr><td>Rasam Wada</td><td>250</td><td colSpan={3}>—</td></tr>
        <tr><td>Ghee Podi Masala Dosa</td><td>300</td><td colSpan={3}>Dairy, Sesame</td></tr>

        {/* ================= PIZZA & PASTA ================= */}
        <tr className="title"><td colSpan={5}>PIZZA &amp; PASTA STAGE – 2 Counters</td></tr>
        <tr className="subHead"><td colSpan={5}>TIME: 11:00 AM – 07:30 PM</td></tr>
        <tr className="head"><td>Item</td><td>Price (₹)</td><td colSpan={3}>Allergens</td></tr>
        <tr><td>Margherita</td><td>300</td><td colSpan={3}>Wheat, Milk</td></tr>
        <tr><td>Olives, Sundried Tomato &amp; Arugula</td><td>350</td><td colSpan={3}>Wheat, Milk</td></tr>
        <tr><td>Penne "Arrabiatta" (Mascarpone &amp; Tomato Crème)</td><td>350</td><td colSpan={3}>Wheat, Milk</td></tr>
        <tr><td>Penne "Alfredo" (Pecorino Fondue)</td><td>350</td><td colSpan={3}>Wheat, Milk</td></tr>
      </table>
    );
  },
  jioCafe2: () => CafeList.jioCafe1(),
  jioCafe3: () => CafeList.jioCafe1(),
  jioCafe4: () => CafeList.jioCafe1(),
  jioCafe5: () => CafeList.jioCafe1(),
  jioCafe6: () => CafeList.jioCafe1(),
};
